(function(){'use strict';if(window.MGTracking)return;var seen=new WeakMap();var steps=new Set(['senderIdentity','storyIntro','trust','pronunciation','favoriteArtist','recipient','occasion','name','names','connection','additionalPeople','proof','genre','mood','moods','voice','perspective','language','details','story','summary','prep','gate','offer','success']);function permitted(){try{var p=window.Shopify.customerPrivacy;return p.analyticsProcessingAllowed()===true&&p.marketingAllowed()===true&&p.saleOfDataAllowed()===true;}catch(_){return false;}}function send(root,name,step,hash,offer){try{if(!permitted()||!window.Shopify.analytics||!window.Shopify.analytics.publish)return;var keys=seen.get(root);if(!keys){keys=new Set();seen.set(root,keys);}var key=name+':'+(step||'');if(keys.has(key))return;keys.add(key);var data={schema_version:1};if(steps.has(step))data.step_id=step;if(name==='mg_lead_saved'&&/^[a-f0-9]{64}$/.test(hash||''))data.match_email_sha256=hash;if(/^(set3490|set_full|pdf)$/.test(offer||''))data.offer=offer;try{Promise.resolve(window.Shopify.analytics.publish(name,data)).catch(function(){keys.delete(key);});}catch(_){keys.delete(key);}}catch(_){}}async function lead(root,email){if(!permitted())return;var hash;try{var value=typeof email==='string'?email.trim().toLowerCase():'';if(value.length<=254&&/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)){var digest=await window.crypto.subtle.digest('SHA-256',new window.TextEncoder().encode(value));hash=Array.from(new Uint8Array(digest),function(b){return b.toString(16).padStart(2,'0');}).join('');}}catch(_){}send(root,'mg_lead_saved',undefined,hash);}function visible(root,node,name){if(!node||!window.IntersectionObserver)return;var observer=new window.IntersectionObserver(function(entries){if(entries.some(function(e){return e.isIntersecting&&e.intersectionRatio>=.25;})&&permitted()){send(root,name);observer.disconnect();}},{threshold:.25});observer.observe(node);}window.MGTracking={event:function(root,name,details){var step=details&&details.step_id;if(name==='mg_answer_select'||name==='mg_step_complete')send(root,'mg_funnel_started');if(name==='mg_step_complete'&&steps.has(step))send(root,'mg_step_completed',step);if(name==='mg_step_view'&&steps.has(step))send(root,'mg_step_viewed',step);if(name==='mg_step_view'&&step==='offer')visible(root,root.querySelector('[data-mg-offer-buybox] h3'),'mg_offer_viewed');if(name==='mg_hoerprobe_ready')send(root,'mg_hoerprobe_ready');if(name==='mg_hoerprobe_play')send(root,'mg_hoerprobe_played');if(/^mg_gift_sheet_(shown|accept|decline|close)$/.test(name))send(root,name,undefined,undefined,details&&details.offer);if(name==='mg_lead_saved')return lead(root,details&&details.email);},preview:function(root,node){visible(root,node,'mg_preview_viewed');}};})();
(function () {
  'use strict';

  if (window.MelodyGlowThemeRuntime) {
    window.MelodyGlowThemeRuntime.init(document);
    return;
  }

  var SAFE_EVENT_FIELDS = ['step_id', 'total_steps', 'path', 'section_id', 'sample_index', 'offer'];
  var FAMILY_ROLES = ['child', 'parent', 'sibling', 'grandparents'];

  // ---------- Sprachpakete (28.10.2026) ----------
  // de und en verhalten sich exakt wie bisher. Jede andere Seitensprache (data-mg-locale="fr" …) liest ihre Texte
  // aus window.MG_PACK (assets/mg-pack-<xx>.js, vom Layout vor dieser Datei geladen). Fehlt das Paket oder ein Text,
  // kommt der englische Text. Schlüssel ist immer der deutsche Text; interne Werte (Anlass, Stil …) bleiben deutsch.
  function mgLocaleCode(value) {
    var raw = String(value == null ? '' : value);
    if (raw === 'en') return 'en';
    var code = raw.toLowerCase().split(/[-_]/)[0];
    return /^[a-z]{2,3}$/.test(code) && code !== 'de' && code !== 'en' ? code : 'de';
  }
  function mgPageLocale() {
    var lang = String(document.documentElement.lang || '');
    return lang.indexOf('en') === 0 ? 'en' : mgLocaleCode(lang);
  }
  function mgPack(locale) {
    if (locale === 'de' || locale === 'en') return null;
    try {
      var pack = window.MG_PACK;
      // Paket gilt nur für seine Sprache (pt-PT-Paket auch für Seiten mit „pt-PT“ → „pt“).
      return pack && typeof pack === 'object' && (!pack.locale || mgLocaleCode(pack.locale) === locale) ? pack : null;
    } catch (_) { return null; }
  }
  function mgPackValue(locale, group, key) {
    try {
      var pack = mgPack(locale), table = pack && pack[group];
      return table && typeof table === 'object' && Object.prototype.hasOwnProperty.call(table, key) ? table[key] : undefined;
    } catch (_) { return undefined; }
  }
  function mgIntl(locale) {
    if (locale === 'en') return 'en-GB';
    if (locale === 'de') return 'de-DE';
    try { var pack = mgPack(locale), tag = pack && pack.intl; if (typeof tag === 'string' && Intl.getCanonicalLocales(tag).length === 1) return tag; } catch (_) {}
    return 'en-GB';
  }
  function mgFill(template, values) {
    return String(template).replace(/\{(\w+)\}/g, function (match, key) {
      return values && Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match;
    });
  }
  function mgText(locale, de, en) {
    if (locale === 'en') return en;
    if (locale === 'de') return de;
    var text = mgPackValue(locale, 'strings', de);
    return typeof text === 'string' ? text : en;
  }
  // Sätze mit Platzhaltern ({name} …). values: Objekt oder function (sprache) für sprachabhängige Werte (Possessiv).
  // Ein Pakettext darf { one: …, other: … } sein (Plural nach values.count).
  function mgFormat(locale, de, en, values) {
    function valuesFor(lang) { return typeof values === 'function' ? values(lang) : values; }
    if (locale === 'en') return mgFill(en, valuesFor('en'));
    if (locale === 'de') return mgFill(de, valuesFor('de'));
    var text = mgPackValue(locale, 'strings', de), local = valuesFor(locale);
    if (text && typeof text === 'object') {
      try { text = text[new Intl.PluralRules(mgIntl(locale)).select(Number(local && local.count))] || text.other; } catch (_) { text = text.other; }
    }
    return typeof text === 'string' ? mgFill(text, local) : mgFill(en, valuesFor('en'));
  }
  // „Gabis“ / „Gabi’s“; Pakete: grammar.possessive = [[RegExp, Vorlage mit {name}], …], erste passende Regel gilt.
  function mgPossessive(locale, name) {
    if (locale === 'en') return name + (/s$/i.test(name) ? '’' : '’s');
    if (locale === 'de') return name + (/[sxzß]$/i.test(name) ? '’' : 's');
    var rules = mgPackValue(locale, 'grammar', 'possessive');
    if (Array.isArray(rules)) {
      for (var index = 0; index < rules.length; index += 1) {
        try { if (new RegExp(rules[index][0], 'i').test(name)) return mgFill(rules[index][1], { name: name }); } catch (_) {}
      }
    }
    return mgPossessive('en', name);
  }
  // Uhrzeit im Fließtext; Pakete: format.time mit {H} (ohne führende Null), {HH}, {mm}, z. B. „14 h 30“.
  function mgTime(locale, date) {
    var pattern = locale === 'de' || locale === 'en' ? '' : mgPackValue(locale, 'format', 'time');
    if (typeof pattern === 'string' && pattern) return mgFill(pattern, { H: date.getHours(), HH: String(date.getHours()).padStart(2, '0'), mm: String(date.getMinutes()).padStart(2, '0') });
    return new Intl.DateTimeFormat(mgIntl(locale), { hour: '2-digit', minute: '2-digit' }).format(date);
  }
  function mgThousands(locale) {
    var separator = locale === 'de' || locale === 'en' ? '' : mgPackValue(locale, 'format', 'thousands');
    return typeof separator === 'string' && separator && separator.indexOf('$') === -1 ? separator : '.';
  }
  // Preise: de/en wie bisher (Shop-Format). Paketsprachen wie das Liquid „{{ x | money_without_currency }}&nbsp;€“: Betrag mit
  // den Trennzeichen des Shop-Formats, geschütztes Leerzeichen, €. Pakete dürfen format.money mit {amount} setzen; andere Währung → Intl.
  function mgMoney(locale, cents, format, currency) {
    if (locale === 'de' || locale === 'en') return formatMoney(cents, format, mgIntl(locale), currency);
    var value = Number(cents) || 0;
    if (currency && currency !== 'EUR') return new Intl.NumberFormat(mgIntl(locale), { style: 'currency', currency: currency }).format(value / 100);
    var placeholder = String(format || '').replace(/<[^>]*>/g, '').match(/\{\{\s*\w+\s*\}\}/);
    var amount = placeholder ? formatMoney(value, placeholder[0]) : '';
    if (!/^-?[\d.,' \u00a0\u202f]+$/.test(amount)) amount = new Intl.NumberFormat(mgIntl(locale), { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value / 100);
    var pattern = mgPackValue(locale, 'format', 'money');
    return mgFill(typeof pattern === 'string' && pattern.indexOf('{amount}') !== -1 ? pattern : '{amount}\u00a0€', { amount: amount });
  }
  // Eigener Name: Das alte EU-Sprachen-Theme nutzte window.MelodyGlowI18n als Wörterbuch; beides darf sich nie überschreiben.
  window.MelodyGlowLocale = { code: mgLocaleCode, page: mgPageLocale, pack: mgPack, value: mgPackValue, intl: mgIntl, fill: mgFill, text: mgText, format: mgFormat, possessive: mgPossessive, time: mgTime, thousands: mgThousands, money: mgMoney };

  function emit(root, eventName, details) {
    try { if (window.MGTracking) window.MGTracking.event(root, eventName, details); } catch (_) {}
    if (root.dataset.analyticsEnabled !== 'true') return;
    var safe = { event: eventName };
    SAFE_EVENT_FIELDS.forEach(function (key) {
      if (details && Object.prototype.hasOwnProperty.call(details, key)) safe[key] = details[key];
    });
    root.dispatchEvent(new CustomEvent('melodyglow:event', { bubbles: true, detail: safe }));
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Horizon scrolls inside .page-wrapper on desktop, so window.scrollTo() is a no-op there.
  // scrollIntoView works for whichever element is the scroll container.
  function scrollToElement(element, block, instant) {
    if (!element) return;
    var behavior = instant || prefersReducedMotion() ? 'instant' : 'smooth';
    try { element.scrollIntoView({ behavior: behavior, block: block || 'start' }); }
    catch (ignore) { element.scrollIntoView(block !== 'end'); }
  }

  // Same output as Liquid's `money` filter, so prices look identical before and after JS updates them.
  function formatMoney(cents, format, locale, currency) {
    var value = Number(cents) || 0;
    var template = String(format || '').replace(/<[^>]*>/g, '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = template.match(placeholder);
    function delimit(precision, thousands, decimal) {
      var parts = (value / 100).toFixed(precision).split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var formats = {
      amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_apostrophe_separator: [2, "'", '.'], amount_with_space_separator: [2, ' ', ','],
      amount_no_decimals_with_space_separator: [0, ' ', '']
    };
    if (match && formats[match[1]]) return template.replace(placeholder, delimit.apply(null, formats[match[1]]));
    return new Intl.NumberFormat(locale || 'de-DE', { style: 'currency', currency: currency || 'EUR' }).format(value / 100);
  }
  window.MelodyGlowFormatMoney = formatMoney;

  function formatAudioTime(seconds) {
    if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
    var minutes = Math.floor(seconds / 60);
    var remainder = Math.floor(seconds % 60);
    return minutes + ':' + String(remainder).padStart(2, '0');
  }

  function initAudios(scope) {
    scope.querySelectorAll('[data-mg-audio]:not([data-mg-ready])').forEach(function (audio, index) {
      audio.dataset.mgReady = 'true';
      var player = document.createElement('div');
      var miniUi = audio.dataset.mgAudioUi === 'mini';
      var compactUi = audio.dataset.mgAudioUi === 'compact' || Boolean(audio.closest('[data-mg-home]'));
      player.className = miniUi ? 'mg-audio-mini' : 'mg-audio-player' + (compactUi ? ' mg-audio-player--compact' : '');
      player.innerHTML = miniUi
        ? '<button class="mg-audio-toggle" type="button"><span aria-hidden="true">▶</span></button><input class="mg-audio-progress" type="hidden" value="0"><span class="mg-audio-time" hidden></span>'
        : '<span class="mg-audio-cover" aria-hidden="true">♪</span><button class="mg-audio-toggle" type="button"><span aria-hidden="true">▶</span></button><label class="mg-audio-progress-wrap"><span class="visually-hidden">Audio position</span><input class="mg-audio-progress" type="range" min="0" max="1000" value="0" step="1"></label><span class="mg-audio-time">0:00</span>';
      audio.insertAdjacentElement('afterend', player);
      audio.controls = false;
      audio.classList.add('mg-audio-source');
      var toggle = player.querySelector('.mg-audio-toggle');
      var progress = player.querySelector('.mg-audio-progress');
      var time = player.querySelector('.mg-audio-time');
      // de/en: Seitensprache wie bisher; andere Sprachen: Sprache des umgebenden Bereichs (FR-Startseite zeigt die EN-Fassung).
      var audioLang=mgPageLocale();if(audioLang!=='de'&&audioLang!=='en'){var audioHome=audio.closest('[data-mg-locale]');if(audioHome)audioLang=mgLocaleCode(audioHome.dataset.mgLocale);}
      var label = audio.getAttribute('aria-label') || mgText(audioLang, 'Audio sample', 'Audio sample');
      toggle.setAttribute('aria-label', label);
      var errorNote=document.createElement('p');errorNote.className='mg-audio-error';errorNote.hidden=true;errorNote.setAttribute('role','status');errorNote.textContent=mgText(audioLang,'Die Hörprobe konnte nicht abgespielt werden. Tippe auf Play, um es erneut zu versuchen.','Could not play this sample. Press play to try again.');player.insertAdjacentElement('afterend',errorNote);

      function syncPlayer() {
        var duration = Number(audio.duration || 0);
        var current = Number(audio.currentTime || 0);
        progress.value = duration > 0 ? String(Math.round((current / duration) * 1000)) : '0';
        time.textContent = formatAudioTime(current) + (duration > 0 ? ' / ' + formatAudioTime(duration) : '');
        toggle.querySelector('span').textContent = audio.paused ? '▶' : 'Ⅱ';
        player.classList.toggle('is-playing', !audio.paused);
      }

      toggle.addEventListener('click', function () {
        if (audio.paused) {
          if(player.classList.contains('is-error')){audio.load();player.classList.remove('is-error');errorNote.hidden=true;}
          var playPromise = audio.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () { player.classList.add('is-error'); errorNote.hidden=false; });
        } else audio.pause();
      });
      progress.addEventListener('input', function () {
        if (Number.isFinite(audio.duration) && audio.duration > 0) audio.currentTime = (Number(progress.value) / 1000) * audio.duration;
      });
      audio.addEventListener('loadedmetadata', syncPlayer);
      audio.addEventListener('timeupdate', syncPlayer);
      audio.addEventListener('pause', syncPlayer);
      audio.addEventListener('ended', syncPlayer);
      audio.addEventListener('error', function () {
        player.classList.add('is-error');
        toggle.disabled = false; errorNote.hidden=false;
        toggle.setAttribute('aria-label', label + mgText(audioLang,' — erneut versuchen',' — retry'));
      });
      audio.addEventListener('play', function () {
        document.querySelectorAll('[data-mg-audio]').forEach(function (otherAudio) {
          if (otherAudio !== audio) otherAudio.pause();
        });
        syncPlayer();
        errorNote.hidden=true; player.classList.remove('is-error');
        var root = audio.closest('.mg-root');
        if (root) emit(root, 'mg_audio_play', { section_id: root.dataset.sectionId || '', sample_index: index + 1 });
      });
      syncPlayer();
    });
  }

  function formatReadyAt(node, hours) {
    var root = node.closest('[data-mg-locale]');
    var lang = mgLocaleCode(root ? root.dataset.mgLocale : '');
    var locale = mgIntl(lang);
    var now = new Date();
    var ready = new Date(now.getTime() + (Math.max(1, Number(hours) || 1) * 60 * 60 * 1000));
    var nowDay = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    var readyDay = Date.UTC(ready.getFullYear(), ready.getMonth(), ready.getDate());
    var dayDifference = Math.round((readyDay - nowDay) / 86400000);
    var dayLabel = dayDifference === 0
      ? mgText(lang, 'heute', 'today')
      : dayDifference === 1
        ? mgText(lang, 'morgen', 'tomorrow')
        : new Intl.DateTimeFormat(locale, { weekday: 'short', day: '2-digit', month: '2-digit' }).format(ready);
    var timeLabel = mgTime(lang, ready);
    return mgFormat(lang, '{day}, {time} Uhr', '{day} at {time}', { day: dayLabel, time: timeLabel });
  }

  function initDeliveryEstimates(scope) {
    scope.querySelectorAll('[data-mg-standard-ready]:not([data-mg-ready])').forEach(function (node) {
      node.dataset.mgReady = 'true';
      node.textContent = formatReadyAt(node, node.dataset.standardHours || 24);
    });
    scope.querySelectorAll('[data-mg-standard-delivery]:not([data-mg-ready])').forEach(function (node) {
      node.dataset.mgReady = 'true';
      var root = node.closest('[data-mg-locale]');
      var locale = mgIntl(mgLocaleCode(root ? root.dataset.mgLocale : ''));
      var days = Math.max(1, Number(node.dataset.deliveryDays || 3));
      var delivery = new Date();
      while (days > 0) {
        delivery.setDate(delivery.getDate() + 1);
        if (delivery.getDay() !== 0 && delivery.getDay() !== 6) days -= 1;
      }
      node.textContent = new Intl.DateTimeFormat(locale, { weekday: 'short', day: '2-digit', month: '2-digit' }).format(delivery);
    });
    scope.querySelectorAll('[data-mg-express-ready]:not([data-mg-ready])').forEach(function (node) {
      node.dataset.mgReady = 'true';
      node.textContent = formatReadyAt(node, node.dataset.expressHours || 2);
    });
  }

  function initCartProof(root) {
    if (root.dataset.mgCartProofReady === 'true') return;
    root.dataset.mgCartProofReady = 'true';
    var total = root.querySelector('[data-mg-cart-total]');
    if (!total) return;
    var timer = 0;
    function refreshTotal() {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
          .then(function (response) { return response.ok ? response.json() : Promise.reject(new Error('cart')); })
          .then(function (cart) {
            total.textContent = new Intl.NumberFormat(mgIntl(mgLocaleCode(root.dataset.mgLocale)), { style: 'currency', currency: cart.currency || 'EUR' }).format(Number(cart.total_price || 0) / 100);
          }).catch(function () {});
      }, 450);
    }
    var cartSection = document.querySelector('[id^="shopify-section-"][id$="cart-section"]');
    if (cartSection && window.MutationObserver) new MutationObserver(refreshTotal).observe(cartSection, { childList: true, subtree: true, characterData: true });
    document.addEventListener('cart:update', refreshTotal);
  }

  function initProduct(root) {
    if (root.dataset.mgProductReady === 'true') return;
    root.dataset.mgProductReady = 'true';
    var select = root.querySelector('[data-mg-variant-select]');
    var price = root.querySelector('[data-mg-product-price] strong');
    var links = root.querySelectorAll('[data-mg-configure-link]');
    if (!select) return;
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      if (price && option && option.dataset.price) price.textContent = option.dataset.price;
      links.forEach(function (link) {
        var url = new URL(link.href, window.location.origin);
        url.searchParams.set('variant', select.value);
        link.href = url.toString();
      });
      emit(root, 'mg_variant_change', { section_id: root.dataset.sectionId || '' });
    });
  }

  function initialState() {
    return {
      recipientPick: '', recipientRole: '', recipientRoleOther: '', occasionPick: '', occasion: '', occasionOther: '',
      recipientName: '', senderNames: '', pronunciation: '', connection: '', connectionOther: '',
      additionalPeople: [], genre: '', genreOther: '', moods: [], senderIdentity: '', voice: '', perspective: 'Ihr dürft entscheiden', language: '',
      languageOther: '', storyOrigin: '', keyMoments: '', traits: [], customTrait: '',
      coreMessage: '', mustInclude: '', mustAvoid: '', additionalNotes: '', favoriteArtist: '', lyricsMode: 'details', finishedLyrics: '',
      email: '', recoveryAccepted: false
    };
  }

  function cleanDraftState(raw) {
    var clean = initialState();
    if (!raw || typeof raw !== 'object') return clean;
    Object.keys(clean).forEach(function (key) {
      if (key === 'recoveryAccepted') return;
      if (key === 'email') return;
      if (Array.isArray(clean[key])) clean[key] = Array.isArray(raw[key]) ? raw[key].slice(0, key === 'additionalPeople' ? 4 : 5).map(String) : [];
      else if (typeof raw[key] === 'string') clean[key] = raw[key].slice(0, ['keyMoments', 'finishedLyrics'].indexOf(key) !== -1 ? 6000 : 1500);
    });
    return clean;
  }

  function makeRequestId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    var bytes = new Uint8Array(16);
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') window.crypto.getRandomValues(bytes);
    else for (var index = 0; index < bytes.length; index += 1) bytes[index] = Math.floor(Math.random() * 256);
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    var hex = Array.prototype.map.call(bytes, function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
    return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
  }

  function fetchWithTimeout(url, options, timeoutMs) {
    if (typeof window.AbortController !== 'function') return fetch(url, options);
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, timeoutMs);
    var requestOptions = Object.assign({}, options, { signal: controller.signal });
    return fetch(url, requestOptions).finally(function () { window.clearTimeout(timer); });
  }

  function initConfigurator(root) {
    if (root.dataset.mgConfiguratorReady === 'true') return;
    root.dataset.mgConfiguratorReady = 'true';

    // Seitensprache: 'de' (auch leer/unbekannt), 'en' oder ein Paket-Code wie 'fr'. isEnglish bedeutet unverändert „Englisch“.
    var MG_LOCALE = mgLocaleCode(root.dataset.mgLocale);
    var isEnglish = MG_LOCALE === 'en';
    function tr(de, en) { return mgText(MG_LOCALE, de, en); }
    function trf(de, en, values) { return mgFormat(MG_LOCALE, de, en, values); }
    function money(cents) { return mgMoney(MG_LOCALE, cents, root.dataset.moneyFormat, root.dataset.currency); }
    var EN_LABELS = {
      'Weniger als ein Jahr': 'Less than one year', '1–3 Jahre': '1–3 years', '4–7 Jahre': '4–7 years',
      '8–15 Jahre': '8–15 years', 'Mehr als 15 Jahre': 'More than 15 years', 'Etwas anderes': 'Something else',
      'Baby oder Kleinkind': 'Baby or toddler', 'Schulkind': 'School-age child', 'Teenager': 'Teenager', 'Erwachsen': 'Adult',
      'Eng und vertraut': 'Close and familiar', 'Voller Dankbarkeit': 'Full of gratitude', 'Viele gemeinsame Jahre': 'Many years together',
      'Wir haben wieder zueinandergefunden': 'We found our way back to each other', 'Seit der Kindheit verbunden': 'Connected since childhood',
      'Durch Höhen und Tiefen': 'Through highs and lows', 'Viele Abenteuer erlebt': 'Shared many adventures', 'Derselbe Humor': 'The same sense of humour',
      'Familie im Herzen': 'Family at heart', 'Durch einen besonderen Moment verbunden': 'Connected by a special moment',
      'Schon viele Jahre': 'For many years', 'Ganz neu in meinem Leben': 'New in my life',
      'Weihnachten': 'Christmas', 'Geburtstag': 'Birthday', 'Hochzeit oder Jahrestag': 'Wedding or anniversary', 'Heiratsantrag': 'Marriage proposal',
      'Geburt oder Taufe': 'Birth or christening', 'Weihnachten': 'Christmas', 'Danke sagen': 'Say thank you',
      'Mut machen oder Trost schenken': 'Encouragement or comfort', 'Einfach so': 'Just because', 'Ein anderer Anlass': 'Another occasion',
      'Pop': 'Pop', 'Ballade': 'Ballad', 'House / Dance': 'House / Dance', 'Schlager': 'German pop',
      'R&B / Soul': 'R&B / Soul', 'Country / Folk': 'Country / Folk', 'Akustik': 'Acoustic',
      'Andere Musikrichtung': 'Another style', 'Ihr dürft entscheiden': 'You decide',
      'Gefühlvoller Deutschpop': 'Emotional German pop', 'Piano-Ballade': 'Piano ballad', 'Moderner Schlager': 'Modern German pop',
      'Rock': 'Rock', 'Rap': 'Rap', 'Überrascht mich': 'Surprise me', 'Tief berührend': 'Deeply moving',
      'Fröhlich': 'Joyful', 'Warm & geborgen': 'Warm & safe', 'Romantisch': 'Romantic', 'Nostalgisch': 'Nostalgic',
      'Leicht & verspielt': 'Light & playful', 'Kraftvoll': 'Powerful', 'Ruhig': 'Calm', 'Hoffnungsvoll': 'Hopeful',
      'Weibliche Stimme': 'Female voice', 'Männliche Stimme': 'Male voice', 'Beide Stimmen': 'Both voices', 'Ihr dürft entscheiden': 'You decide',
      'Direkt mit du': 'Directly using “you”', 'Über die Person erzählt': 'Told about the person',
      'Aus unserer wir-Perspektive': 'From our “we” perspective', 'Deutsch': 'German', 'Englisch': 'English',
      'Deutsch & Englisch gemischt': 'German & English mixed', 'Andere Sprache': 'Another language',
      'Herzlich': 'Warm-hearted', 'Humorvoll': 'Funny', 'Mutig': 'Brave', 'Verlässlich': 'Reliable',
      'Lebensfroh': 'Full of life', 'Kreativ': 'Creative', 'Für andere da': 'Always there for others',
      'Ein bisschen chaotisch': 'A little chaotic', 'Etwas Eigenes': 'Something else'
    };
    function localizedLabel(value) {
      if (MG_LOCALE === 'de') return value;
      var label = isEnglish ? undefined : mgPackValue(MG_LOCALE, 'labels', value);
      return typeof label === 'string' && label ? label : (EN_LABELS[value] || value);
    }

    var intro = root.querySelector('[data-mg-intro]');
    var flow = root.querySelector('[data-mg-flow]');
    var form = root.querySelector('[data-mg-briefing-form]');
    var startButton = root.querySelector('[data-mg-start]');
    var resetButton = root.querySelector('[data-mg-reset]');
    var discardPendingButton = root.querySelector('[data-mg-discard-pending]');
    var editProfileButtons = root.querySelectorAll('[data-mg-edit-profile]');
    var jumpOfferButtons = root.querySelectorAll('[data-mg-jump-offer]');
    var saveButton = root.querySelector('[data-mg-save]');
    var submitButton = root.querySelector('[data-mg-submit]');
    var submitButtonMarkup=submitButton.innerHTML;
    var offerOnlyButton = root.querySelector('[data-mg-offer-only]');
    var checkoutButton = root.querySelector('[data-mg-checkout]');
    var checkoutButtons = root.querySelectorAll('[data-mg-checkout], [data-mg-checkout-sticky]');
    var nextButton = root.querySelector('[data-mg-next]');
    var backButton = root.querySelector('[data-mg-back]');
    var nav = root.querySelector('[data-mg-nav]');
    var errorBox = root.querySelector('[data-mg-error]');
    var phaseLabel = root.querySelector('[data-mg-phase]');
    var counterLabel = root.querySelector('[data-mg-counter]');
    var progressBar = root.querySelector('[data-mg-progress]');
    var progressWrap = root.querySelector('.mg-progress');
    var draftKey = root.dataset.draftKey || 'melodyglow-song-draft-v3';
    // Keeps carts saved by the previous configurator version reachable after the draft key changed.
    var pendingCartKey = (root.dataset.pendingKey || draftKey) + '-pending-cart';
var verifiedRecoveryCredit=null;
function activeCreditCents(){var c=verifiedRecoveryCredit;return c&&c.configuration_id===savedConfigurationId&&String(c.product_variant_id)===String(pendingVariantId)&&c.currency===root.dataset.currency&&c.amount_cents===1276&&/^MG1276-[A-Z0-9]{30}$/.test(c.code||'')&&Date.parse(c.expires_at)>Date.now()?Math.min(c.amount_cents,Number(root.dataset.basePriceCents)||0):0;}
// Komplett mit 2h-Express + Geschenk-Sheet „zweite Chance“ (29.10.2026). Die Rabatte legt der Inhaber in Shopify an:
// - automatische Rabattaktion: Express 100 %, sobald Songtext-PDF + Instrumental + Streaming im Warenkorb sind (Schalter komplett_express);
// - Rabattcode GIFT_SET_CODE: 5,00 € auf den Acrylaufsteller, wenn das Set über das Sheet dazukommt (Schalter gift_sheet_set_offer).
// Beides nie zusammen mit einem MG1276-Guthaben (die Guthaben-Codes sind mit keinem anderen Rabatt kombinierbar) und der Set-Code nie zusammen mit Express inklusive.
var GIFT_SET_CODE='MGSET',GIFT_SET_SAVING_CENTS=500,giftOffer='',giftCodeInCart=false;
function addonInput(kind){return root.querySelector('[data-mg-addon][data-mg-addon-kind="'+kind+'"]');}
function checkedKinds(){return Array.prototype.slice.call(root.querySelectorAll('[data-mg-addon]:checked')).map(function(n){return n.dataset.mgAddonKind;});}
function addonCentsOf(kinds){return kinds.reduce(function(sum,k){var n=addonInput(k);return sum+(n?Number(n.dataset.priceCents||0):0);},0);}
function bundleExpressOn(){return Boolean(root.querySelector('[data-mg-package="complete"][data-mg-bundle-express]'))&&root.dataset.mgBundleBroken!=='true'&&!activeCreditCents();}
function bundleExpressCents(kinds){var x=addonInput('express');return x&&bundleExpressOn()&&['express','pdf','instrumental','streaming'].every(function(k){return kinds.indexOf(k)!==-1&&addonInput(k);})?Number(x.dataset.priceCents||0):0;}
function giftSetOfferOn(){return Boolean(root.querySelector('[data-mg-gift-sheet][data-mg-gift-offer]'))&&root.dataset.mgGiftOfferBroken!=='true'&&!activeCreditCents();}
function giftSetSavingCents(kinds,offer){return offer==='set'&&giftSetOfferOn()&&kinds.indexOf('acrylic')!==-1&&kinds.indexOf('pdf')!==-1&&!bundleExpressCents(kinds)?GIFT_SET_SAVING_CENTS:0;}
function offerAdjustCents(kinds,offer){return bundleExpressCents(kinds)+giftSetSavingCents(kinds,offer);}
function syncOfferMarkers(kinds){
var on=bundleExpressOn(),included=bundleExpressCents(kinds),setCut=giftSetSavingCents(kinds,giftOffer);
root.dataset.mgBundle=on?'on':'off';root.dataset.mgExpressIncluded=included?'true':'false';
root.dataset.mgGiftSaving=giftOffer==='set'&&giftSetOfferOn()?String(GIFT_SET_SAVING_CENTS):'0';
root.dataset.mgGiftSetCents=setCut?String(addonCentsOf(['acrylic','pdf'])-setCut):'0';
root.querySelectorAll('[data-mg-bundle-only]').forEach(function(n){n.style.display=on?'':'none';});
var note=root.querySelector('[data-mg-bundle-note]');if(note&&(!on||note.hasAttribute('data-mg-note'))){if(!note.hasAttribute('data-mg-note'))note.setAttribute('data-mg-note',note.textContent);note.textContent=on?note.getAttribute('data-mg-note'):tr('Paketpreise · 2h-Express bei jedem Paket zubuchbar','Package prices · 2-hour express can be added to any package');}
var x=addonInput('express'),label=x&&x.closest('label'),b=label&&Array.prototype.filter.call(label.children,function(c){return c.tagName==='B';})[0];
if(b&&(included||b.hasAttribute('data-mg-price'))){if(!b.hasAttribute('data-mg-price'))b.setAttribute('data-mg-price',b.textContent);b.textContent=included?tr('inklusive','included'):b.getAttribute('data-mg-price');}
}
function renderOfferSavings(){
var base=Number(root.dataset.basePriceCents),credit=activeCreditCents(),sale=(MG_LOCALE==='de'||MG_LOCALE==='en')&&root.dataset.currency==='EUR'&&base>0&&base<9995;
root.dataset.mgCreditCents=String(credit);
var oldNote=root.querySelector('[data-mg-savings-note]');if(oldNote)oldNote.remove();
var row=root.querySelector('[data-mg-order-overview] .mg-total-row');
if(row){
var banner=root.querySelector('[data-mg-sale-banner]');
if(!banner){banner=document.createElement('div');banner.setAttribute('data-mg-sale-banner','');banner.style.cssText='display:flex;align-items:center;justify-content:space-between;gap:16px;padding:16px 20px;margin:16px 0;border-radius:14px;background:linear-gradient(110deg,#542044,#813960);color:#fff';var copy=document.createElement('div');var label=document.createElement('small');label.textContent=tr('MELODYGLOW ANGEBOT','MELODYGLOW OFFER');label.style.cssText='display:block;font-size:10px;letter-spacing:.12em;font-weight:600;color:#f2dce9';var title=document.createElement('strong');title.setAttribute('data-mg-sale-amount','');title.style.cssText='display:block;font-size:24px;line-height:1.25;margin:3px 0;color:#fff';var sub=document.createElement('span');sub.textContent=tr('auf deinen persönlichen Song','on your personal song');sub.style.cssText='font-size:13px;color:#f2dce9';copy.append(label,title,sub);var icon=document.createElement('span');icon.textContent='♫';icon.setAttribute('aria-hidden','true');icon.style.cssText='font-size:48px;line-height:1;color:#eccddf;padding:0 4px;transform:rotate(-10deg)';banner.append(copy,icon);row.before(banner);}
banner.hidden=!sale;banner.style.display=sale?'flex':'none';if(sale)banner.querySelector('[data-mg-sale-amount]').textContent=new Intl.NumberFormat(mgIntl(MG_LOCALE),{style:'currency',currency:'EUR',maximumFractionDigits:0}).format((9995-base)/100)+tr(' Rabatt',' off');
var old=row.querySelector('[data-mg-regular-total]');if(!old){old=document.createElement('del');old.setAttribute('data-mg-regular-total','');old.style.cssText='font-size:14px;font-weight:400;color:#8b7c84;white-space:nowrap;margin-left:auto;margin-right:10px';row.insertBefore(old,row.querySelector('[data-mg-offer-total]'));}old.hidden=!sale;if(sale)old.textContent=money(9995+selectedOfferAddons().reduce(function(sum,a){return sum+a.cents;},0)-offerAdjustCents(checkedKinds(),giftOffer));
}
root.dispatchEvent(new CustomEvent('mg:price-updated'));
}

    var draftEnabled = root.dataset.draftEnabled === 'true';
    var draftMaxAge = 14 * 24 * 60 * 60 * 1000;
    var state = initialState();
    var currentId = 'recipient';
    var started = false;
    var requestId = makeRequestId();
    var savedConfigurationId = '';
    var intakeAttempted = false;
    var cartAttemptedAt = 0;
    var checkoutStartedAt = 0;
    var briefingLocked = false;
    var pendingVariantId = '';
    var submitInFlight = false;
    var autoAdvanceTimer = 0;
    var detailsNudgeShown = false;
    var anonymousSubmitWaiting = false;

    // Answers on the first two steps are text tiles; each tile maps to the worker's fixed enums.
    var RECIPIENT_PICKS = {
      'partner-m': { role: 'partner', de: 'Ehemann oder Partner', en: 'Husband or partner', whoDe: 'dein Mann', whoEn: 'your husband' },
      'partner-f': { role: 'partner', de: 'Ehefrau oder Partnerin', en: 'Wife or partner', whoDe: 'deine Frau', whoEn: 'your wife' },
      mama: { role: 'parent', de: 'Mama', en: 'Mum', whoDe: 'deine Mama', whoEn: 'your mum' },
      papa: { role: 'parent', de: 'Papa', en: 'Dad', whoDe: 'dein Papa', whoEn: 'your dad' },
      tochter: { role: 'child', de: 'Tochter', en: 'Daughter', whoDe: 'deine Tochter', whoEn: 'your daughter' },
      sohn: { role: 'child', de: 'Sohn', en: 'Son', whoDe: 'dein Sohn', whoEn: 'your son' },
      enkel: { role: 'other', de: 'Enkelkind', en: 'Grandchild', whoDe: 'dein Enkelkind', whoEn: 'your grandchild' },
      freundin: { role: 'friend', de: 'Freundin', en: 'Friend (female)', whoDe: 'deine Freundin', whoEn: 'your friend' },
      freund: { role: 'friend', de: 'Freund', en: 'Friend (male)', whoDe: 'dein Freund', whoEn: 'your friend' },
      schwester: { role: 'sibling', de: 'Schwester', en: 'Sister', whoDe: 'deine Schwester', whoEn: 'your sister' },
      bruder: { role: 'sibling', de: 'Bruder', en: 'Brother', whoDe: 'dein Bruder', whoEn: 'your brother' },
      oma: { role: 'grandparents', de: 'Oma', en: 'Grandma', whoDe: 'deine Oma', whoEn: 'your grandma' },
      opa: { role: 'grandparents', de: 'Opa', en: 'Grandpa', whoDe: 'dein Opa', whoEn: 'your grandpa' },
      other: { role: 'other', de: '', en: '', whoDe: 'die Person', whoEn: 'the person' }
    };
    var OCCASION_PICKS = {
      weihnachten: { occasion: 'Weihnachten' },
      geburtstag: { occasion: 'Geburtstag' },
      jahrestag: { occasion: 'Hochzeit oder Jahrestag', de: 'Jahrestag', en: 'Anniversary' },
      hochzeit: { occasion: 'Hochzeit oder Jahrestag', de: 'Hochzeit', en: 'Wedding' },
      liebe: { occasion: 'Einfach so', de: 'Liebeserklärung', en: 'Declaration of love' },
      einfachso: { occasion: 'Einfach so' },
      danke: { occasion: 'Danke sagen' },
      trost: { occasion: 'Mut machen oder Trost schenken' },
      antrag: { occasion: 'Heiratsantrag' },
      geburt: { occasion: 'Geburt oder Taufe' },
      erinnerung: { occasion: 'Ein anderer Anlass', de: 'In Erinnerung an einen geliebten Menschen', en: 'In memory of a loved one' },
      ruhestand: { occasion: 'Ein anderer Anlass', de: 'Ruhestand', en: 'Retirement' },
      other: { occasion: 'Ein anderer Anlass' }
    };
    // Paket-Sprachen: Kachel-Texte aus MG_PACK.picks.recipient[id] = { label, who } bzw. picks.occasion[id] = label; sonst Englisch.
    function packPick(kind, id) {
      var table = mgPackValue(MG_LOCALE, 'picks', kind);
      return table && typeof table === 'object' && Object.prototype.hasOwnProperty.call(table, id) ? table[id] : undefined;
    }
    function pickLabel(kind, id, pick) {
      if (MG_LOCALE === 'de' || isEnglish) return tr(pick.de, pick.en);
      var entry = packPick(kind, id), label = entry && typeof entry === 'object' ? entry.label : entry;
      return typeof label === 'string' && label ? label : pick.en;
    }
    function pickWho(id, pick, lang) {
      if (lang === 'de') return pick.whoDe;
      if (lang === 'en') return pick.whoEn;
      var entry = packPick('recipient', id);
      return entry && typeof entry.who === 'string' && entry.who ? entry.who : pick.whoEn;
    }
    function recipientFields() {
      var pick = RECIPIENT_PICKS[state.recipientPick];
      if (!pick) return { role: state.recipientRole, other: state.recipientRole === 'other' ? state.recipientRoleOther : '' };
      if (state.recipientPick === 'other') return { role: 'other', other: state.recipientRoleOther.trim() };
      return { role: pick.role, other: pickLabel('recipient', state.recipientPick, pick) };
    }
    function occasionFields() {
      var pick = OCCASION_PICKS[state.occasionPick];
      if (!pick) return { occasion: state.occasion, other: state.occasion === 'Ein anderer Anlass' ? state.occasionOther : '' };
      if (state.occasionPick === 'other') return { occasion: 'Ein anderer Anlass', other: state.occasionOther.trim() };
      return { occasion: pick.occasion, other: pick.de ? pickLabel('occasion', state.occasionPick, pick) : '' };
    }
    function possessiveName(lang) {
      var name = state.recipientName.trim();
      if (!name) return mgText(lang || MG_LOCALE, 'Dein', 'Your');
      return mgPossessive(lang || MG_LOCALE, name);
    }
    function possessiveValues(lang) { return { who: possessiveName(lang) }; }
    // Vorbelegte Freitext-Knöpfe (FR, 28.10.2026): data-choice="genre|language" mit dem internen Wert „Andere Musikrichtung“ /
    // „Andere Sprache“ plus data-mg-other-text="Variété française" / "Französisch". Ein Klick füllt genreOther/languageOther,
    // das Freitextfeld bleibt verborgen und wird nicht verlangt. Ohne solche Knöpfe (DE/EN) ändert sich nichts.
    var OTHER_TEXT_FIELDS = { genre: 'genreOther', language: 'languageOther' };
    var otherPresets = {}; // Schlüssel → gewählter Vorgabetext, false = normaler Knopf angetippt, fehlt = aus dem Zustand ableiten
    function activePreset(key) {
      if (!Object.prototype.hasOwnProperty.call(OTHER_TEXT_FIELDS, key) || otherPresets[key] === false) return null;
      var buttons = root.querySelectorAll('[data-choice="' + key + '"][data-mg-other-text]');
      for (var index = 0; index < buttons.length; index += 1) {
        var text = buttons[index].dataset.mgOtherText;
        if (buttons[index].dataset.value === state[key] && text === state[OTHER_TEXT_FIELDS[key]] && (otherPresets[key] === undefined || otherPresets[key] === text)) return buttons[index];
      }
      return null;
    }
    function choiceSelected(button, preset) {
      if (state[button.dataset.choice] !== button.dataset.value) return false;
      if (!Object.prototype.hasOwnProperty.call(OTHER_TEXT_FIELDS, button.dataset.choice)) return true;
      if (preset === undefined) preset = activePreset(button.dataset.choice);
      return button.hasAttribute('data-mg-other-text') ? button === preset : !preset;
    }
    function selectedChoiceButton(key) {
      var preset = activePreset(key);
      return Array.prototype.find.call(root.querySelectorAll('[data-choice="' + key + '"]'), function (button) { return choiceSelected(button, preset); });
    }
    function applyOtherPreset(choice, presetBefore) {
      var key = choice.dataset.choice, field = OTHER_TEXT_FIELDS[key];
      if (!Object.prototype.hasOwnProperty.call(OTHER_TEXT_FIELDS, key)) return;
      if (choice.hasAttribute('data-mg-other-text')) { state[field] = String(choice.dataset.mgOtherText || ''); otherPresets[key] = state[field]; return; }
      // Von einem Vorgabe-Knopf zum normalen Knopf mit demselben Wert („Andere Musikrichtung“ / „Andere Sprache“): leeres Feld statt des Vorgabetexts.
      if (presetBefore && state[key] === presetBefore.dataset.value) state[field] = '';
      otherPresets[key] = false;
    }
    // Anzeige eines vorbelegten Freitexts (z. B. „Französisch“ → „Français“ über MG_PACK.labels).
    function presetLabel(key) {
      var preset = activePreset(key);
      return preset ? localizedLabel(preset.dataset.mgOtherText) : '';
    }
    function genreLabel() {
      var preset = presetLabel('genre');
      if (preset) return preset;
      if (state.genre === 'Andere Musikrichtung') return state.genreOther.trim() || tr('eigene Richtung', 'your own style');
      if (!state.genre || state.genre === 'Ihr dürft entscheiden') return tr('passend zu eurer Geschichte', 'to fit your story');
      return localizedLabel(state.genre);
    }
    function voiceLabel() {
      return ({ 'Weibliche Stimme': tr('Frauenstimme', 'female voice'), 'Männliche Stimme': tr('Männerstimme', 'male voice'), 'Beide Stimmen': tr('Duett', 'duet') })[state.voice] || tr('passend zum Song', 'to fit the song');
    }

    // Short preparation screen between the questions and the email step. The Hörprobe starts here.
    var prepTimer = 0;
    function runPreparation() {
      var list = root.querySelector('[data-mg-prep-list]');
      window.clearTimeout(prepTimer);
      var name = state.recipientName.trim();
      var items = [
        tr('Deine Antworten werden sortiert', 'Sorting your answers'),
        tr('Musikstil: ', 'Style: ') + genreLabel(),
        tr('Stimme: ', 'Voice: ') + voiceLabel(),
        name ? trf('Erste Zeilen für {name} entstehen', 'First lines for {name} are taking shape', { name: name }) : tr('Erste Zeilen entstehen', 'First lines are taking shape'),
        tr('Melodie wird vorbereitet', 'Preparing the melody')
      ];
      var nodes = [];
      if (list) {
        list.textContent = '';
        nodes = items.map(function (text) { var item = document.createElement('li'); item.textContent = text; list.appendChild(item); return item; });
      }
      var stepMs = prefersReducedMotion() ? 280 : 900, index = 0;
      function tick() {
        if (currentId !== 'prep') return;
        if (index > 0 && nodes[index - 1]) { nodes[index - 1].classList.remove('is-active'); nodes[index - 1].classList.add('is-done'); }
        if (index < nodes.length) { nodes[index].classList.add('is-active'); index += 1; prepTimer = window.setTimeout(tick, stepMs); return; }
        prepTimer = window.setTimeout(function () { if (currentId === 'prep') showStep('gate'); }, prefersReducedMotion() ? 150 : 450);
      }
      tick();
    }

    // Hörprobe: started with a Turnstile token during the preparation screen, bound to the saved
    // profile at intake (worker add-on) and polled on the offer page until the first minute is playable.
    var HP_CREATIVE_FIELDS = ['recipientRole', 'recipientRoleOther', 'occasion', 'occasionOther', 'recipientName', 'pronunciation', 'genre', 'genreOther', 'voice', 'language', 'languageOther', 'keyMoments', 'favoriteArtist', 'lyricsMode', 'finishedLyrics', 'customerLocale'];
    var wishState = { saved: '', open: false, saving: false, rev: 0 };
    var hp = { receipt: null, key: '', requestId: '', skipKey: '', off: false, promise: null, waiting: false, cancel: false, access: null, startedAt: 0, status: '', title: '', audioUrl: '', timer: 0, ticker: 0, errors: 0, shown: false, played: false, refreshed: false, toastTimer: 0 };
    var hpAudio = root.querySelector('[data-mg-hp-audio]');
    function hpEndpoint(path) {
      try { var url = new URL(String(root.dataset.webhookUrl || '')); return url.protocol === 'https:' ? url.origin + path : ''; } catch (ignore) { return ''; }
    }
    function hoerprobeProfile() {
      var profile = webhookPayload(selectedVariantId());
      // The worker validates this anonymous profile with the strict field list (no email, no consent fields).
      delete profile.email; delete profile.emailConsentVersion; profile.recoveryAccepted = false;
      return profile;
    }
    function hoerprobeKey(profile) {
      return requestId + '|' + JSON.stringify(HP_CREATIVE_FIELDS.map(function (key) { return profile[key]; }));
    }
    function startHoerprobe() {
      if (savedConfigurationId || root.dataset.turnstileEnabled !== 'true' || !selectedVariantId()) return;
      var url = hpEndpoint('/api/hoerprobe/start');
      if (!url) return;
      var profile = hoerprobeProfile(), key = hoerprobeKey(profile);
      // off: the start route does not exist (add-on not deployed); skipKey: the worker said unavailable for these answers.
      if (hp.off || hp.skipKey === key) return;
      if (hp.key === key && (hp.promise || hp.receipt)) return;
      if (hp.promise) {
        // Answers changed while an older start was still running: let it finish, then start again.
        hp.cancel = true;
        hp.promise.then(function () { if (currentId === 'prep' || currentId === 'gate') startHoerprobe(); });
        return;
      }
      hp.key = key; hp.requestId = requestId; hp.receipt = null; hp.cancel = false; hp.waiting = true;
      hp.promise = (async function () {
        var usedToken = false, routeMissing = false;
        try {
          var token = await waitForTurnstileToken(30000, function () { return hp.cancel || Boolean(savedConfigurationId); });
          hp.waiting = false;
          if (!token || hp.cancel || savedConfigurationId) return;
          usedToken = true;
          var response = await fetchWithTimeout(url, { method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'CF-Turnstile-Response': token }, body: JSON.stringify(profile) }, 15000);
          var result = {};
          try { result = await response.json(); } catch (ignore) {}
          if (response.status === 404 || response.status === 405) { hp.off = true; routeMissing = true; return; }
          if (response.ok && result.status === 'unavailable') { hp.skipKey = key; return; }
          if (response.ok && result.receipt && /^hp_[0-9a-f]{32}$/.test(String(result.receipt.id || '')) && hp.key === key) {
            hp.receipt = result.receipt;
            hp.startedAt = Date.now();
            emit(root, 'mg_hoerprobe_start', { section_id: root.dataset.sectionId || '', step_id: currentId });
          }
        } catch (ignore) {
        } finally {
          hp.waiting = false; hp.promise = null; syncGateBadge();
          // Turnstile tokens are single-use; the intake gets a fresh one if it still needs it.
          // Without the route nothing verified the token, so the intake can still use it.
          if (usedToken && !routeMissing) resetTurnstile();
        }
      })();
    }
    // "Hörprobe wird komponiert" only while a start is running or accepted (not when paused, limited or failed).
    function syncGateBadge() {
      var badge = root.querySelector('[data-mg-gate-badge]');
      if (badge) badge.hidden = !(hp.promise || usableHoerprobeReceipt());
    }
    async function settleHoerprobeStart() {
      if (!hp.promise) return;
      if (hp.waiting) hp.cancel = true; // Still waiting for a token: the intake needs it more.
      await Promise.race([hp.promise, new Promise(function (resolve) { window.setTimeout(resolve, 8000); })]);
    }
    function usableHoerprobeReceipt() {
      var receipt = hp.receipt;
      return receipt && hp.requestId === requestId && Number(receipt.expires) * 1000 > Date.now() + 60000 ? receipt : null;
    }
    function stopHoerprobePolling() {
      window.clearTimeout(hp.timer); window.clearInterval(hp.ticker); hp.timer = 0; hp.ticker = 0;
    }
    function resetHoerprobe() {
      stopHoerprobePolling();
      hp.cancel = true; hp.receipt = null; hp.key = ''; hp.requestId = ''; hp.access = null; hp.startedAt = 0;
      hp.status = ''; hp.final = false; hp.title = ''; hp.audioUrl = ''; hp.excerptSeconds = 0; hp.errors = 0; hp.shown = false; hp.played = false; hp.refreshed = false;
      wishState.saved = ''; wishState.open = false; wishState.rev += 1;
      var wishText = root.querySelector('[data-mg-wish-text]');
      if (wishText) wishText.value = '';
      setWishStatus('');
      if (hpAudio) { hpAudio.pause(); hpAudio.removeAttribute('src'); try { hpAudio.load(); } catch (ignore) {} }
      var card = root.querySelector('[data-mg-hp]');
      if (card) card.classList.remove('is-started', 'is-playing');
      var after = root.querySelector('[data-mg-hp-after]');
      if (after) after.hidden = true;
      var toast = root.querySelector('[data-mg-hp-toast]');
      if (toast) toast.hidden = true;
    }
    // ---------- Änderungswunsch zum finalen Song (unter der Hörprobe) ----------
    function wishBox() { return root.querySelector('[data-mg-wish]'); }
    function setWishStatus(message, isError) {
      var status = root.querySelector('[data-mg-wish-status]');
      if (!status) return;
      status.textContent = message || '';
      status.classList.toggle('is-error', Boolean(isError));
    }
    function updateWishCount() {
      var box = wishBox(); if (!box) return;
      var text = box.querySelector('[data-mg-wish-text]'), count = box.querySelector('[data-mg-wish-count]');
      if (text && count) count.textContent = text.value.length + ' / 1000';
    }
    function renderWish() {
      var box = wishBox(); if (!box) return;
      var mode = hoerprobeMode();
      var show = currentId === 'offer' && Boolean(savedConfigurationId) && Boolean(hp.access) && hp.access.configuration_id === savedConfigurationId
        && hp.status !== 'none' && (mode === 'ready' || mode === 'fallback');
      box.hidden = !show;
      var note = root.querySelector('[data-mg-hp-note]');
      if (note) note.textContent = wishState.saved
        ? tr('Die erste Minute deines Songs. Nach der Bestellung bekommst du ihn in voller Länge – mit deinem Änderungswunsch.', 'The first minute of your song. After your order you receive it in full length – with your change request.')
        : tr('Die erste Minute deines Songs. Nach der Bestellung bekommst du genau diesen Song in voller Länge.', 'The first minute of your song. After your order you receive exactly this song in full length.');
      if (!show) return;
      var label = box.querySelector('[data-mg-wish-toggle-label]');
      if (label) label.textContent = mode === 'ready'
        ? tr('Möchtest du am finalen Song etwas ändern?', 'Want to change something in your final song?')
        : tr('Hast du noch einen besonderen Wunsch für deinen Song?', 'Any special request for your song?');
      var toggle = box.querySelector('[data-mg-wish-toggle]'), panel = box.querySelector('[data-mg-wish-panel]'), saved = box.querySelector('[data-mg-wish-saved]');
      var hasSaved = Boolean(wishState.saved);
      toggle.hidden = hasSaved || wishState.open;
      toggle.setAttribute('aria-expanded', wishState.open ? 'true' : 'false');
      panel.hidden = !wishState.open;
      saved.hidden = !hasSaved || wishState.open;
      var wishLabel = box.querySelector('[data-mg-wish-label]');
      if (wishLabel) wishLabel.textContent = mode === 'ready'
        ? tr('Dein Änderungswunsch für den finalen Song', 'Your change request for the final song')
        : tr('Dein Wunsch für deinen Song', 'Your request for your song');
      var wishNote = box.querySelector('[data-mg-wish-note]');
      if (wishNote) wishNote.textContent = mode === 'ready'
        ? tr('Wir setzen ihn nach deiner Bestellung im finalen Song um. Bei kleinen Änderungen bleibt die Melodie, die du gerade hörst.', 'We apply it to your final song after your order. Small changes keep the melody you are hearing now.')
        : tr('Wir berücksichtigen ihn nach deiner Bestellung in deinem Song.', 'We take it into account for your song after your order.');
      var savedText = box.querySelector('[data-mg-wish-saved-text]');
      if (savedText) savedText.textContent = wishState.saved;
      updateWishCount();
    }
    function openWish() {
      var box = wishBox(); if (!box) return;
      var wasOpen = wishState.open;
      wishState.open = true;
      var text = box.querySelector('[data-mg-wish-text]');
      if (text && !wasOpen) text.value = wishState.saved;
      setWishStatus('');
      renderWish();
      if (text) { try { text.focus({ preventScroll: false }); } catch (ignore) { text.focus(); } }
      if (!wasOpen) emit(root, 'mg_hoerprobe_wish_open', { section_id: root.dataset.sectionId || '', step_id: currentId });
    }
    async function saveWish(options) {
      var box = wishBox(); if (!box || wishState.saving) return false;
      var quiet = Boolean(options && options.quiet);
      var text = box.querySelector('[data-mg-wish-text]');
      var message = text ? text.value.trim() : '';
      if (message.length > 0 && message.length < 3) { if (!quiet) setWishStatus(tr('Bitte beschreibe deinen Wunsch etwas genauer.', 'Please describe your request in a little more detail.'), true); return false; }
      if (!message && !wishState.saved) { wishState.open = false; renderWish(); return true; }
      var url = hpEndpoint('/api/hoerprobe/wish');
      if (!url || !hp.access) return false;
      var forId = savedConfigurationId;
      var button = box.querySelector('[data-mg-wish-save]');
      wishState.saving = true; wishState.rev += 1; if (button) button.disabled = true;
      if (!quiet) setWishStatus(tr('Wird gespeichert …', 'Saving …'));
      try {
        var response = await fetchWithTimeout(url, { method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ access: hp.access, message: message }) }, quiet ? 6000 : 15000);
        var data = {};
        try { data = await response.json(); } catch (ignore) {}
        if (forId !== savedConfigurationId) return false;
        if (response.ok && data && data.ok) {
          wishState.saved = data.saved ? message : ''; wishState.open = false;
          setWishStatus('');
          savePendingCart();
          emit(root, 'mg_hoerprobe_wish', { section_id: root.dataset.sectionId || '', step_id: currentId, saved: Boolean(data.saved), length: message.length });
          renderWish();
          return true;
        }
        if (!quiet) setWishStatus(data && data.code === 'ORDER_IN_PRODUCTION'
          ? tr('Dein Song ist schon in Produktion. Änderungen kannst du danach direkt auf deiner Songseite anfragen.', 'Your song is already in production. You can request changes on your song page afterwards.')
          : data && data.code === 'WISH_TOO_LONG'
            ? tr('Bitte fasse deinen Wunsch etwas kürzer (höchstens 1000 Zeichen).', 'Please keep your request a little shorter (max. 1000 characters).')
            : tr('Das Speichern hat gerade nicht geklappt. Bitte versuche es noch einmal.', 'Saving did not work just now. Please try again.'), true);
        return false;
      } catch (error) {
        if (!quiet) setWishStatus(tr('Das Speichern hat gerade nicht geklappt. Bitte versuche es noch einmal.', 'Saving did not work just now. Please try again.'), true);
        return false;
      } finally {
        wishState.saving = false; if (button) button.disabled = false;
      }
    }
    // Vor dem Checkout: einen getippten, aber noch nicht gespeicherten Wunsch mitnehmen.
    async function flushWish() {
      var box = wishBox();
      if (!box || box.hidden || !wishState.open) return;
      var text = box.querySelector('[data-mg-wish-text]');
      var message = text ? text.value.trim() : '';
      if (message.length < 3 || message === wishState.saved) return;
      try { await saveWish({ quiet: true }); } catch (ignore) {}
    }
    function initWish() {
      var box = wishBox(); if (!box) return;
      box.addEventListener('click', function (event) {
        if (event.target.closest('[data-mg-wish-toggle], [data-mg-wish-edit]')) { openWish(); return; }
        if (event.target.closest('[data-mg-wish-save]')) saveWish();
      });
      var text = box.querySelector('[data-mg-wish-text]');
      if (text) {
        text.addEventListener('input', function () { updateWishCount(); setWishStatus(''); });
        text.addEventListener('keydown', function (event) { if ((event.ctrlKey || event.metaKey) && event.key === 'Enter') { event.preventDefault(); saveWish(); } });
      }
    }
    function hoerprobeMode() {
      if (hp.status === 'ready' && hp.audioUrl) return 'ready';
      return ['failed', 'unavailable', 'none'].indexOf(hp.status) !== -1 ? 'fallback' : 'pending';
    }
    function updateHoerprobeProgress() {
      var elapsed = Math.max(0, Date.now() - (hp.startedAt || Date.now()));
      var bar = root.querySelector('[data-mg-hp-progress]');
      if (bar) bar.style.width = Math.min(96, 6 + (elapsed / 120000) * 90).toFixed(1) + '%';
      var status = root.querySelector('[data-mg-hp-status]');
      if (!status) return;
      var name = state.recipientName.trim();
      var composing = hp.status === 'composing' || (!hp.status && elapsed > 40000);
      var text = composing
        ? (elapsed > 100000 ? tr('Gleich geschafft – letzter Feinschliff …', 'Almost there – final touches …') : tr('Melodie und Gesang entstehen …', 'Melody and vocals are being recorded …'))
        : (name ? trf('Der Songtext für {name} wird geschrieben …', 'The lyrics for {name} are being written …', { name: name }) : tr('Dein Songtext wird geschrieben …', 'Your lyrics are being written …'));
      if (elapsed > 200000) text = tr('Dauert heute etwas länger – noch einen Moment …', 'Taking a little longer today – just a moment …');
      if (status.textContent !== text) status.textContent = text;
      var hint = root.querySelector('[data-mg-hp-hint]');
      if (hint) {
        if (!hint.dataset.mgDefault) hint.dataset.mgDefault = hint.textContent;
        var late = sw.ran && sw.t0 && Date.now() - sw.t0 >= swSeconds('mgSwMax', 180) * 1000;
        var hintText = !late ? hint.dataset.mgDefault : state.recoveryAccepted
          ? tr('Deine Hörprobe braucht heute länger als sonst. Wir schicken dir den Link per E-Mail, sobald sie fertig ist. Deine Angaben sind gespeichert – du kannst trotzdem schon bestellen.', 'Your sample is taking longer than usual today. We will email you the link as soon as it is ready. Your details are saved – you can already order.')
          : tr('Deine Hörprobe braucht heute länger als sonst. Sie erscheint hier automatisch, sobald sie fertig ist. Deine Angaben sind gespeichert – du kannst trotzdem schon bestellen.', 'Your sample is taking longer than usual today. It will appear here automatically as soon as it is ready. Your details are saved – you can already order.');
        if (hint.textContent !== hintText) hint.textContent = hintText;
      }
    }
    function renderHoerprobe() {
      var card = root.querySelector('[data-mg-hp]');
      if (!card) return;
      var mode = hoerprobeMode(), name = state.recipientName.trim(), who = possessiveName();
      card.dataset.state = mode;
      var banner = root.querySelector('[data-mg-hp-banner]');
      if (banner) {
        if (root.dataset.mgSwBanner === 'pending' && mode !== 'pending') { if (mode === 'ready') root.dataset.mgSwBanner = 'ready'; else delete root.dataset.mgSwBanner; }
        var bannerText = root.dataset.mgSwBanner === 'pending' ? tr('Deine Hörprobe lädt noch kurz – sie erscheint hier oben automatisch.', 'Your sample is still loading – it will appear right here automatically.')
          : root.dataset.mgSwBanner === 'ready' ? tr('Deine Hörprobe ist fertig – hier oben anhören.', 'Your sample is ready – listen right here.') : '';
        if (banner.textContent !== bannerText) banner.textContent = bannerText;
        banner.hidden = !bannerText;
      }
      card.querySelector('[data-mg-hp-pending]').hidden = mode !== 'pending';
      card.querySelector('[data-mg-hp-ready]').hidden = mode !== 'ready';
      card.querySelector('[data-mg-hp-fallback]').hidden = mode !== 'fallback';
      var kicker = root.querySelector('[data-mg-hp-kicker]');
      var title = root.querySelector('[data-offer-title]');
      var songTitle = root.querySelector('[data-mg-hp-title]');
      var cta = root.querySelector('[data-mg-hp-cta]');
      if (kicker) kicker.textContent = mode === 'pending' ? tr('Deine Hörprobe entsteht', 'Your sample is being created') : mode === 'ready' ? tr('Deine persönliche Hörprobe', 'Your personal sample') : tr('Dein persönlicher Song', 'Your personal song');
      if (title) title.textContent = mode === 'pending'
        ? (name ? trf('{who} Song entsteht gerade.', '{who} song is being created.', possessiveValues) : tr('Dein Song entsteht gerade.', 'Your song is being created.'))
        : mode === 'ready'
          ? (name ? trf('Das ist {who} Song.', 'This is {who} song.', possessiveValues) : tr('Das ist dein Song.', 'This is your song.'))
          : (name ? trf('Dein persönlicher Song für {name}.', 'Your personal song for {name}.', { name: name }) : tr('Dein persönlicher Song.', 'Your personal song.'));
      if (songTitle) songTitle.textContent = mode === 'ready' && hp.title ? trf('„{title}“', '“{title}”', { title: hp.title }) : tr('Ein Song für ', 'A song for ') + (name || tr('deinen Herzensmenschen', 'your special person'));
      if (cta) cta.textContent = name ? trf('Song für {name} sichern', 'Get {name}’s song', function (lang) { return { name: name, who: possessiveName(lang) }; }) : tr('Deinen Song sichern', 'Secure your song');
      if (mode === 'pending') {
        updateHoerprobeProgress();
        if (!hp.ticker && currentId === 'offer') hp.ticker = window.setInterval(function () { if (currentId === 'offer' && hoerprobeMode() === 'pending') updateHoerprobeProgress(); }, 700);
      } else { window.clearInterval(hp.ticker); hp.ticker = 0; }
      if (mode === 'fallback') {
        var note = root.querySelector('[data-mg-hp-fallback-text]');
        var sampleButton = selectedChoiceButton('genre');
        var ownStyle = Boolean(sampleButton && sampleButton.parentElement.querySelector('audio'));
        var sampleLead = ownStyle ? tr('So klingt dein gewählter Musikstil:', 'This is how your chosen style sounds:') : tr('Ein Hörbeispiel aus unserem Angebot:', 'A sample from our collection:');
        var text = hp.status === 'none'
          ? sampleLead
          : (hp.status === 'unavailable'
            ? tr('Deine Hörprobe ist gerade nicht verfügbar. Deine Angaben sind gespeichert – du kannst trotzdem bestellen.', 'Your sample is not available right now. Your details are saved – you can still order.')
            // The worker reported a final failure: nothing will follow by email, the full song is produced as usual.
            : hp.final
            ? tr('Deine Hörprobe konnte diesmal leider nicht erstellt werden. Deine Angaben sind gespeichert – du kannst trotzdem bestellen, dein Song wird wie gewohnt in voller Länge für dich produziert.', 'Your sample could not be created this time. Your details are saved – you can still order; your full song will be produced for you as usual.')
            : tr('Deine Hörprobe braucht gerade länger als gewohnt. Deine Angaben sind gespeichert – du kannst trotzdem schon bestellen.', 'Your sample is taking longer than usual. Your details are saved – you can still order.')
              + (state.recoveryAccepted ? tr(' Über den Link in unserer E-Mail kannst du sie später anhören.', ' You can listen to it later via the link in our email.') : ''))
            + ' ' + sampleLead;
        if (note) note.textContent = text;
      }
      renderWish();
    }
    function showHoerprobeToast() {
      var card = root.querySelector('[data-mg-hp]');
      if (!card || currentId !== 'offer') return;
      var rect = card.getBoundingClientRect(), viewport = window.innerHeight || document.documentElement.clientHeight;
      if (rect.bottom > 0 && rect.top < viewport) return;
      var toast = root.querySelector('[data-mg-hp-toast]');
      if (!toast) {
        toast = document.createElement('div'); toast.className = 'mg-hp-toast'; toast.setAttribute('data-mg-hp-toast', ''); toast.setAttribute('role', 'status');
        var text = document.createElement('span'); text.textContent = tr('♪ Deine Hörprobe ist fertig', '♪ Your sample is ready');
        var button = document.createElement('button'); button.type = 'button'; button.textContent = tr('Anhören', 'Listen');
        button.addEventListener('click', function () {
          toast.hidden = true; scrollToElement(card, 'center');
          window.setTimeout(function () { var play = root.querySelector('[data-mg-hp-play]'); if (play) try { play.focus({ preventScroll: true }); } catch (ignore) {} }, 450);
        });
        toast.append(text, button); root.appendChild(toast);
      }
      toast.hidden = false;
      window.clearTimeout(hp.toastTimer);
      hp.toastTimer = window.setTimeout(function () { toast.hidden = true; }, 15000);
    }
    function hoerprobeReady() {
      if (hpAudio && hpAudio.getAttribute('src') !== hp.audioUrl) { hpAudio.setAttribute('src', hp.audioUrl); try { hpAudio.load(); } catch (ignore) {} }
      if (hp.shown) return;
      hp.shown = true;
      emit(root, 'mg_hoerprobe_ready', { section_id: root.dataset.sectionId || '', step_id: 'offer' });
      try { if (window.MGTracking) window.MGTracking.preview(root, root.querySelector('[data-mg-hp]')); } catch (_) {}
      showHoerprobeToast();
    }
    function scheduleHoerprobePoll() {
      var elapsed = Date.now() - (hp.startedAt || Date.now());
      if (hp.errors >= 5 || elapsed > 14 * 60000) { hp.status = 'failed'; renderHoerprobe(); return; }
      renderHoerprobe();
      hp.timer = window.setTimeout(pollHoerprobe, elapsed < 150000 ? 3000 : 10000);
    }
    function pollHoerprobe() {
      window.clearTimeout(hp.timer); hp.timer = 0;
      if ((currentId !== 'offer' && currentId !== 'songwait') || !savedConfigurationId) return;
      if (hp.status === 'ready' && hp.audioUrl) { renderHoerprobe(); hoerprobeReady(); return; }
      if (['failed', 'unavailable', 'none'].indexOf(hp.status) !== -1) { renderHoerprobe(); return; }
      var url = hpEndpoint('/api/hoerprobe/status');
      if (!url || !hp.access || hp.access.configuration_id !== savedConfigurationId) { hp.status = 'none'; renderHoerprobe(); return; }
      if (!hp.startedAt) hp.startedAt = Date.now();
      var forId = savedConfigurationId, wishRev = wishState.rev;
      fetchWithTimeout(url, { method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ access: hp.access }) }, 15000)
        .then(function (response) { return response.json().catch(function () { return {}; }).then(function (data) { return { ok: response.ok, code: response.status, data: data || {} }; }); })
        .then(function (result) {
          if (forId !== savedConfigurationId || (currentId !== 'offer' && currentId !== 'songwait')) return;
          var data = result.data;
          // Der gespeicherte Wunsch kommt vom Worker (z. B. nach Reload oder über den E-Mail-Link).
          if (result.ok && !wishState.open && !wishState.saving && wishRev === wishState.rev) wishState.saved = typeof data.wish === 'string' ? data.wish.slice(0, 1000) : '';
          if (result.ok && data.status === 'ready' && /^https:\/\//.test(String(data.audio_url || ''))) {
            hp.status = 'ready'; hp.title = String(data.title || '').slice(0, 160); hp.audioUrl = String(data.audio_url);
            hp.excerptSeconds = Number(data.excerpt_seconds) > 0 ? Number(data.excerpt_seconds) : 0;
            renderHoerprobe(); hoerprobeReady(); savePendingCart(); return;
          }
          if (result.ok && ['failed', 'unavailable', 'expired'].indexOf(data.status) !== -1) { hp.status = data.status === 'unavailable' ? 'unavailable' : 'failed'; hp.final = hp.status === 'failed'; renderHoerprobe(); return; }
          if (result.code === 401 || result.code === 403) { hp.status = 'none'; renderHoerprobe(); return; }
          if (result.ok && data.status) { hp.status = String(data.status); hp.errors = 0; } else hp.errors += 1;
          scheduleHoerprobePoll();
        })
        .catch(function () { if (forId !== savedConfigurationId) return; hp.errors += 1; scheduleHoerprobePoll(); });
    }
    // Ladescreen vor dem Angebot (24.10.2026): erst die Hörprobe, dann der Preis. Nur direkt nach dem E-Mail-Schritt;
    // Reload, Resume-Link und Rückkehr von der Kasse gehen wie bisher direkt zum Angebot.
    var sw = { t0: 0, timer: 0, slideTimer: 0, slide: 0, finishing: null, ran: false, done: false };
    function swSeconds(name, fallback) {
      var value = Number(root.dataset[name]);
      return root.dataset[name] !== undefined && root.dataset[name] !== '' && Number.isFinite(value) && value >= 0 ? value : fallback;
    }
    function songwaitArm() {
      var mode = root.dataset.mgSongwait || 'off';
      if (mode === 'on' || /[?&]mg_sw=1(&|$)/.test(window.location.search)) return true;
      // Test: vorletzte Hex-Stelle der Konfigurations-ID (ungerade = Ladescreen), unabhängig von der letzten Stelle.
      return mode === 'test' && /^mg_[0-9a-f]{32}$/.test(savedConfigurationId) && parseInt(savedConfigurationId.slice(-2, -1), 16) % 2 === 1;
    }
    function songwaitApplies() {
      return Boolean(root.querySelector('[data-step="songwait"]')) && songwaitArm() && Boolean(hp.access)
        && hp.access.configuration_id === savedConfigurationId && hoerprobeMode() !== 'fallback';
    }
    function swCurve(seconds) {
      // Schnell auf 45 %, dann langsam Richtung 90 %; die letzten 10 % kommen, sobald die Hörprobe fertig ist.
      return seconds <= 8 ? 45 * (1 - Math.pow(1 - seconds / 8, 2)) : 45 + 45 * (1 - Math.exp(-(seconds - 8) / 30));
    }
    function stopSongwait() {
      window.clearTimeout(sw.timer); window.clearInterval(sw.slideTimer); sw.timer = 0; sw.slideTimer = 0;
    }
    function startSongwaitSlides() {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mg-sw-slide]'));
      var dots = root.querySelector('[data-mg-sw-dots]');
      window.clearInterval(sw.slideTimer); sw.slide = 0;
      if (!slides.length) return;
      if (dots && dots.children.length !== slides.length) { dots.textContent = ''; slides.forEach(function () { dots.appendChild(document.createElement('i')); }); }
      function show(index) {
        slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
        if (dots) Array.prototype.forEach.call(dots.children, function (dot, i) { dot.classList.toggle('is-active', i === index); });
      }
      show(0);
      if (slides.length > 1) sw.slideTimer = window.setInterval(function () { sw.slide = (sw.slide + 1) % slides.length; show(sw.slide); }, 5000);
    }
    function startSongwait() {
      stopSongwait();
      sw.t0 = Date.now(); sw.finishing = null; sw.ran = true; sw.done = false;
      var wait = root.querySelector('[data-mg-sw-wait]'), done = root.querySelector('[data-mg-sw-done]');
      if (wait) wait.hidden = false;
      if (done) done.hidden = true;
      var name = state.recipientName.trim(), title = root.querySelector('[data-mg-sw-title]'), lyrics = root.querySelector('[data-sw-step="lyrics"]');
      if (title) title.textContent = name ? trf('{who} Song entsteht gerade.', '{who} song is being created.', possessiveValues) : tr('Dein Song entsteht gerade.', 'Your song is being created.');
      if (lyrics) lyrics.textContent = name ? trf('Songtext für {name} wird geschrieben', 'Writing the lyrics for {name}', { name: name }) : tr('Dein Songtext wird geschrieben', 'Writing your lyrics');
      emit(root, 'mg_songwait_shown', { section_id: root.dataset.sectionId || '', step_id: 'songwait' });
      startSongwaitSlides();
      pollHoerprobe();
      swTick();
    }
    function swRender(pct, seconds) {
      var bar = root.querySelector('[data-mg-sw-progress]'), wrap = root.querySelector('[data-mg-sw-bar]'), pctNode = root.querySelector('[data-mg-sw-pct]');
      if (bar) bar.style.width = pct.toFixed(1) + '%';
      if (wrap) wrap.setAttribute('aria-valuenow', String(Math.round(pct)));
      if (pctNode) pctNode.textContent = Math.floor(pct) + ' %';
      var ready = hoerprobeMode() === 'ready';
      var sinceStart = Date.now() - (hp.startedAt || sw.t0);
      var composing = ready || hp.status === 'composing' || (!hp.status && sinceStart > 40000);
      root.querySelectorAll('[data-sw-step]').forEach(function (item) {
        var step = item.dataset.swStep;
        var isDone = step === 'saved' || (step === 'lyrics' && composing) || ((step === 'music' || step === 'ready') && ready);
        var active = !isDone && ((step === 'lyrics' && !composing) || (step === 'music' && composing));
        item.classList.toggle('is-done', isDone); item.classList.toggle('is-active', active);
      });
      var status = root.querySelector('[data-mg-sw-status]'), name = state.recipientName.trim();
      var text = ready ? tr('Fertig!', 'Done!')
        : composing ? (seconds > 50 ? tr('Gleich geschafft – letzter Feinschliff …', 'Almost there – final touches …') : tr('Melodie und Gesang entstehen …', 'Melody and vocals are being recorded …'))
        : (name ? trf('Der Songtext für {name} wird geschrieben …', 'The lyrics for {name} are being written …', { name: name }) : tr('Dein Songtext wird geschrieben …', 'Your lyrics are being written …'));
      if (status && status.textContent !== text) status.textContent = text;
    }
    function swTick() {
      window.clearTimeout(sw.timer); sw.timer = 0;
      if (currentId !== 'songwait' || sw.done) return;
      var seconds = (Date.now() - sw.t0) / 1000, mode = hoerprobeMode(), pct = swCurve(seconds);
      if (mode === 'fallback') { showStep('offer'); return; }
      if (mode === 'ready' && seconds >= swSeconds('mgSwMin', 10)) {
        if (!sw.finishing) sw.finishing = { at: Date.now(), from: pct };
        var share = Math.min(1, (Date.now() - sw.finishing.at) / 800);
        pct = sw.finishing.from + (100 - sw.finishing.from) * share;
        swRender(pct, seconds);
        if (share >= 1) { showSongwaitDone(seconds); return; }
      } else if (mode !== 'ready' && seconds >= swSeconds('mgSwSwitch', 90)) {
        root.dataset.mgSwBanner = 'pending';
        emit(root, 'mg_songwait_switch', { section_id: root.dataset.sectionId || '', step_id: 'songwait', seconds: Math.round(seconds) });
        showStep('offer');
        return;
      } else swRender(pct, seconds);
      var skip = root.querySelector('[data-mg-sw-skip]');
      if (skip) skip.hidden = !(root.dataset.mgSwSkipLink === 'true' && seconds >= 45);
      sw.timer = window.setTimeout(swTick, 100);
    }
    function showSongwaitDone(seconds) {
      var wait = root.querySelector('[data-mg-sw-wait]'), done = root.querySelector('[data-mg-sw-done]');
      if (!wait || !done) { showStep('offer'); return; }
      stopSongwait(); sw.done = true;
      var name = state.recipientName.trim(), title = done.querySelector('[data-mg-sw-done-title]'), song = done.querySelector('[data-mg-sw-song]');
      if (title) title.textContent = name ? trf('{who} Song ist fertig.', '{who} song is ready.', possessiveValues) : tr('Dein Song ist fertig.', 'Your song is ready.');
      if (song) song.textContent = hp.title ? trf('„{title}“', '“{title}”', { title: hp.title }) : tr('Ein Song für ', 'A song for ') + (name || tr('deinen Herzensmenschen', 'your special person'));
      wait.hidden = true; done.hidden = false;
      if (title) try { title.focus({ preventScroll: true }); } catch (ignore) {}
      emit(root, 'mg_songwait_done', { section_id: root.dataset.sectionId || '', step_id: 'songwait', seconds: Math.round(seconds) });
    }
    function initSongwait() {
      var listen = root.querySelector('[data-mg-sw-listen]'), skip = root.querySelector('[data-mg-sw-skip]');
      if (listen) listen.addEventListener('click', function () {
        emit(root, 'mg_songwait_listen', { section_id: root.dataset.sectionId || '', step_id: 'songwait' });
        showStep('offer');
        // Same tap starts the sample, so mobile browsers allow the playback.
        var play = root.querySelector('[data-mg-hp-play]');
        if (play && hpAudio && hpAudio.getAttribute('src') && hpAudio.paused) play.click();
      });
      if (skip) skip.addEventListener('click', function () {
        emit(root, 'mg_songwait_skip', { section_id: root.dataset.sectionId || '', step_id: 'songwait', seconds: Math.round((Date.now() - sw.t0) / 1000) });
        root.dataset.mgSwBanner = 'pending';
        showStep('offer');
      });
      if (hpAudio) hpAudio.addEventListener('play', function () {
        if (!root.dataset.mgSwBanner) return;
        delete root.dataset.mgSwBanner;
        var banner = root.querySelector('[data-mg-hp-banner]');
        if (banner) banner.hidden = true;
      });
    }
    function initHoerprobePlayer() {
      var card = root.querySelector('[data-mg-hp]');
      if (!hpAudio || !card) return;
      var play = card.querySelector('[data-mg-hp-play]'), seek = card.querySelector('[data-mg-hp-seek]');
      var time = card.querySelector('[data-mg-hp-time]'), total = card.querySelector('[data-mg-hp-duration]');
      var error = card.querySelector('[data-mg-hp-error]'), after = card.querySelector('[data-mg-hp-after]');
      function sync() {
        var duration = Number(hpAudio.duration), known = Number.isFinite(duration) && duration > 0, current = Number(hpAudio.currentTime || 0);
        // The excerpt is a frame copy without a VBR header, so browsers guess it too long (1:25 instead of 1:00): use the worker's length.
        if (hp.excerptSeconds > 0) { duration = hp.excerptSeconds; known = true; current = hpAudio.ended ? duration : Math.min(current, duration); }
        seek.value = known ? String(Math.round((current / duration) * 1000)) : '0';
        time.textContent = formatAudioTime(current);
        if (known) total.textContent = formatAudioTime(duration);
        play.querySelector('span').textContent = hpAudio.paused ? '▶' : 'Ⅱ';
        play.setAttribute('aria-label', hpAudio.paused ? tr('Hörprobe abspielen', 'Play your sample') : tr('Hörprobe pausieren', 'Pause your sample'));
        card.classList.toggle('is-playing', !hpAudio.paused);
        // Gentle fade over the last seconds of the excerpt (ignored where volume is read-only, e.g. iOS).
        if (known && !hpAudio.paused && duration - current < 3.5) { try { hpAudio.volume = Math.max(0.05, (duration - current) / 3.5); } catch (ignore) {} }
      }
      play.addEventListener('click', function () {
        if (!hpAudio.getAttribute('src')) return;
        if (!hpAudio.paused) { hpAudio.pause(); return; }
        if (hpAudio.ended || (hpAudio.duration && hpAudio.currentTime >= hpAudio.duration - 0.2)) hpAudio.currentTime = 0;
        try { hpAudio.volume = 1; } catch (ignore) {}
        error.hidden = true;
        var attempt = hpAudio.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(function () { error.hidden = false; });
      });
      seek.addEventListener('input', function () {
        var length = hp.excerptSeconds > 0 ? hp.excerptSeconds : Number(hpAudio.duration);
        if (!Number.isFinite(length) || length <= 0) return;
        hpAudio.currentTime = (Number(seek.value) / 1000) * length;
        try { hpAudio.volume = 1; } catch (ignore) {}
      });
      ['loadedmetadata', 'timeupdate', 'pause'].forEach(function (type) { hpAudio.addEventListener(type, sync); });
      hpAudio.addEventListener('play', function () {
        card.classList.add('is-started'); sync();
        document.querySelectorAll('audio').forEach(function (other) { if (other !== hpAudio) other.pause(); });
        if (!hp.played) { hp.played = true; emit(root, 'mg_hoerprobe_play', { section_id: root.dataset.sectionId || '', step_id: 'offer' }); }
      });
      hpAudio.addEventListener('ended', function () { sync(); try { hpAudio.volume = 1; } catch (ignore) {} after.hidden = false; });
      hpAudio.addEventListener('error', function () {
        if (!hpAudio.getAttribute('src')) return;
        // The signed audio link may have expired (24 h): fetch a fresh one once.
        if (!hp.refreshed && currentId === 'offer') { hp.refreshed = true; hp.status = ''; hp.audioUrl = ''; hp.startedAt = Date.now() - 600000; pollHoerprobe(); return; }
        error.hidden = false;
      });
      document.addEventListener('play', function (event) { if (event.target !== hpAudio && event.target instanceof HTMLMediaElement) hpAudio.pause(); }, true);
      sync();
    }

    function savePendingCart() {
      if (!savedConfigurationId || !pendingVariantId) return;
      try {
        window.localStorage.setItem(pendingCartKey, JSON.stringify({
          selected_addon_ids: selectedOfferAddons().map(function(x){return x.id;}),
          hoerprobe_access: hp.access,
          hoerprobe_started_at: hp.startedAt || 0,
          hoerprobe_wish: wishState.saved,
          configuration_id: savedConfigurationId,
          variant_id: pendingVariantId,
          cart_attempted_at: cartAttemptedAt,
          checkout_at: checkoutStartedAt,
          gift_offer: giftOffer,
          gift_code_in_cart: giftCodeInCart,
          saved_at: Date.now()
        }));
      } catch (ignore) {}
    }

    function clearPendingCart() {
      try { window.localStorage.removeItem(pendingCartKey); } catch (ignore) {}
    }

    function restorePendingCart() {
      try {
        var raw = window.localStorage.getItem(pendingCartKey);
        if (!raw) return false;
        var pending = JSON.parse(raw);
        if (!pending || !/^mg_[0-9a-f]{32}$/.test(String(pending.configuration_id || '')) || !/^\d{6,20}$/.test(String(pending.variant_id || '')) || !Number.isFinite(Number(pending.saved_at)) || Date.now() - Number(pending.saved_at) > draftMaxAge) {
          clearPendingCart(); return false;
        }
        hp.access = pending.hoerprobe_access && pending.hoerprobe_access.configuration_id === pending.configuration_id ? pending.hoerprobe_access : null;
        hp.startedAt = Math.max(0, Number(pending.hoerprobe_started_at) || 0);
        wishState.saved = typeof pending.hoerprobe_wish === 'string' ? pending.hoerprobe_wish.slice(0, 1000) : '';
        savedConfigurationId = String(pending.configuration_id);
        pendingVariantId = String(pending.variant_id);
        cartAttemptedAt = Math.max(0, Number(pending.cart_attempted_at) || 0);
        checkoutStartedAt = Math.max(0, Number(pending.checkout_at) || 0);
        giftOffer = pending.gift_offer === 'set' ? 'set' : ''; giftCodeInCart = pending.gift_code_in_cart === true;
        if(Array.isArray(pending.selected_addon_ids)) root.querySelectorAll('[data-mg-addon]').forEach(function(input){input.checked=pending.selected_addon_ids.indexOf(String(input.value))!==-1;});
        // Back from the checkout: the cart decides (verifyCheckoutReturn) whether the offer comes back.
        currentId = checkoutStartedAt ? 'loading' : 'offer';
        started = true;
        setBriefingLocked(true);
        return true;
      } catch (ignore) {
        clearPendingCart(); return false;
      }
    }

    function resetTurnstile() {
      if (root.dataset.turnstileEnabled === 'true' && window.turnstile && typeof window.turnstile.reset === 'function') {
        try { window.turnstile.reset(); } catch (ignore) {}
      }
    }

    function syncBriefingLock() {
      root.querySelectorAll('[data-field], [data-choice], [data-multi], [data-add-person], [data-remove-person]').forEach(function (control) {
        if (briefingLocked) control.disabled = true;
        else if (!control.hasAttribute('data-multi')) control.disabled = false;
      });
      root.querySelectorAll('[data-mg-addon],[data-mg-package]').forEach(function(control){control.disabled=submitInFlight;});
      backButton.disabled = briefingLocked;
      if (briefingLocked) backButton.setAttribute('aria-disabled', 'true'); else backButton.removeAttribute('aria-disabled');
      var lockedNote = root.querySelector('[data-mg-locked-note]');
      if (lockedNote) lockedNote.hidden = !briefingLocked;
      if (discardPendingButton) {
        discardPendingButton.hidden = !briefingLocked;
        discardPendingButton.disabled = submitInFlight;
      }
    }

    function setBriefingLocked(locked) {
      briefingLocked = locked === true;
      syncBriefingLock();
    }

    function markBriefingChanged() {
      if (briefingLocked) return false;
      if (intakeAttempted) {
        requestId = makeRequestId();
        intakeAttempted = false;
        cartAttemptedAt = 0;
        resetTurnstile();
      }
      return true;
    }

    function isFamily() { return FAMILY_ROLES.indexOf(state.recipientRole) !== -1; }
    function pathName() { return isFamily() ? 'family' : 'standard'; }
    function normalizeDependentState() {
      if (state.recipientPick ? state.recipientPick !== 'other' : state.recipientRole !== 'other') state.recipientRoleOther = '';
      if (!isFamily()) state.additionalPeople = [];
      if (state.occasionPick ? state.occasionPick !== 'other' : state.occasion !== 'Ein anderer Anlass') state.occasionOther = '';
      if (state.connection !== 'Etwas anderes') state.connectionOther = '';
      if (state.genre !== 'Andere Musikrichtung') state.genreOther = '';
      if (state.language !== 'Andere Sprache') state.languageOther = '';
      if (state.traits.indexOf('Etwas Eigenes') === -1) state.customTrait = '';
    }
    function sequence() {
      return ['recipient', 'occasion', 'name', 'genre', 'voice', 'language', 'details'];
    }
    function questionIds() {
      return sequence().filter(function (id) {
        var panel = root.querySelector('[data-step="' + id + '"]');
        return panel && panel.dataset.kind === 'question';
      });
    }

    function totalStepCount() { return questionIds().length; }

    // Single-choice steps move on by themselves; free-text answers ("Jemand anderes …") need the button.
    var AUTO_STEP_KEYS = { recipient: 'recipientPick', occasion: 'occasionPick', genre: 'genre', voice: 'voice', language: 'language' };
    var enteredWithAnswer = false;
    function isAutomaticChoiceStep(id) {
      return Object.prototype.hasOwnProperty.call(AUTO_STEP_KEYS, id);
    }

    function choiceNeedsDetails(id) {
      if (id === 'recipient') return state.recipientPick === 'other';
      if (id === 'genre') return state.genre === 'Andere Musikrichtung' && !activePreset('genre');
      if (id === 'occasion') return state.occasionPick === 'other';
      if (id === 'language') return state.language === 'Andere Sprache' && !activePreset('language');
      return false;
    }

    function syncNavigation() {
      var terminal = ['prep', 'gate', 'songwait', 'loading', 'offer', 'success'].indexOf(currentId) !== -1;
      var automatic = isAutomaticChoiceStep(currentId) && !choiceNeedsDetails(currentId) && !enteredWithAnswer;
      nextButton.hidden = terminal || currentId === 'summary' || automatic;
      backButton.hidden = (terminal && currentId !== 'gate') || currentId === 'recipient';
      nav.hidden = (terminal && currentId !== 'gate') || (nextButton.hidden && backButton.hidden);
      nav.classList.toggle('mg-config-nav--static', currentId === 'gate');
      nextButton.textContent = currentId === 'details' ? tr('Weiter zur Hörprobe →', 'Continue to your sample →') : tr('Weiter →', 'Continue →');
    }

    function scheduleAutomaticAdvance(stepId) {
      window.clearTimeout(autoAdvanceTimer);
      if (!isAutomaticChoiceStep(stepId) || choiceNeedsDetails(stepId)) {
        syncNavigation();
        return;
      }
      // Short pause so the tap visibly lands on the tile before the next question appears.
      autoAdvanceTimer = window.setTimeout(function () {
        if (currentId === stepId && !briefingLocked) next();
      }, prefersReducedMotion() ? 120 : 280);
    }

    function saveDraft() {
      if (!draftEnabled || !started || currentId === 'success') return;
      var localState = Object.assign({}, state, { email: '', recoveryAccepted: false });
      try { window.localStorage.setItem(draftKey, JSON.stringify({ state: localState, currentId: currentId, requestId: requestId, savedAt: Date.now() })); } catch (ignore) {}
    }

    function restoreDraft() {
      if (!draftEnabled) return false;
      try {
        var raw = window.localStorage.getItem(draftKey);
        if (!raw) return false;
        var parsed = JSON.parse(raw);
        if (!Number.isFinite(Number(parsed.savedAt)) || Date.now() - Number(parsed.savedAt) > draftMaxAge) {
          window.localStorage.removeItem(draftKey); return false;
        }
        state = cleanDraftState(parsed.state);
        normalizeDependentState();
        currentId = typeof parsed.currentId === 'string' ? parsed.currentId : 'recipient';
        if (['loading', 'songwait', 'offer', 'success', 'gate'].indexOf(currentId) !== -1) currentId = 'prep';
        requestId = typeof parsed.requestId === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(parsed.requestId) ? parsed.requestId : makeRequestId();
        return true;
      } catch (ignore) {
        try { window.localStorage.removeItem(draftKey); } catch (ignored) {}
        return false;
      }
    }

    function resetState() {
      state = initialState();
      otherPresets = {};
      state.language = '';
      currentId = 'recipient';
      requestId = makeRequestId();
      savedConfigurationId = '';
      intakeAttempted = false;
      cartAttemptedAt = 0;
      checkoutStartedAt = 0;
      pendingVariantId = '';
      giftOffer = '';
      clearPendingCart();
      resetHoerprobe();
      setBriefingLocked(false);
      root.querySelectorAll('[data-mg-addon]').forEach(function (input) { input.checked = false; });
      updateOfferTotal();
      if (draftEnabled) {
        try { window.localStorage.removeItem(draftKey); } catch (ignore) {}
      }
      syncAllFields();
    }

    // Errors appear next to the question or button they belong to instead of below the whole step.
    var ERROR_ANCHORS = {
      recipient: '[data-step="recipient"] > .mg-options',
      recipientOther: '[data-show-when="recipientPick:other"]',
      occasion: '[data-step="occasion"] > .mg-options',
      occasionOther: '[data-show-when="occasionPick:other"]',
      name: '[data-step="name"] .mg-name-field',
      genreOther: '[data-show-when="genre:Andere Musikrichtung"]',
      language: '[data-step="language"] > .mg-options',
      languageOther: '[data-show-when="language:Andere Sprache"]',
      details: '[data-step="details"] .mg-story-tools',
      finishedLyrics: '[data-show-when="lyricsMode:finishedLyrics"]'
    };
    var ERROR_FOCUS = { recipientOther: '[data-field="recipientRoleOther"]', occasionOther: '[data-field="occasionOther"]', name: '[data-field="recipientName"]', genreOther: '[data-field="genreOther"]', languageOther: '[data-field="languageOther"]', finishedLyrics: '[data-field="finishedLyrics"]' };
    function setError(message, anchorKey, isHint) {
      root.querySelectorAll('[aria-invalid="true"]').forEach(function (field) { field.removeAttribute('aria-invalid'); });
      if (!message) { errorBox.hidden = true; errorBox.textContent = ''; errorBox.classList.remove('is-hint'); return; }
      var anchor = anchorKey && ERROR_ANCHORS[anchorKey] ? root.querySelector(ERROR_ANCHORS[anchorKey]) : null;
      if (!anchor && currentId === 'gate') anchor = root.querySelector('[data-mg-offer-only]') || submitButton;
      if (!anchor && currentId === 'offer') anchor = checkoutButton;
      if (anchor && anchor.offsetParent !== null) anchor.insertAdjacentElement('afterend', errorBox);
      else form.insertBefore(errorBox, nav);
      errorBox.textContent = message;
      errorBox.classList.toggle('is-hint', isHint === true);
      errorBox.hidden = false;
      var field = anchorKey && ERROR_FOCUS[anchorKey] ? root.querySelector(ERROR_FOCUS[anchorKey]) : null;
      if (field) { field.setAttribute('aria-invalid', 'true'); try { field.focus({ preventScroll: true }); } catch (ignore) {} }
      scrollToElement(errorBox, 'center');
    }

    function renderPeople() {
      var list = root.querySelector('[data-people-list]');
      var add = root.querySelector('[data-add-person]');
      if (!list) return;
      list.textContent = '';
      state.additionalPeople.forEach(function (person, index) {
        var row = document.createElement('div'); row.className = 'mg-person-row';
        var input = document.createElement('input'); input.className = 'mg-field'; input.type = 'text'; input.maxLength = 60; input.placeholder = tr('Weitere Person ', 'Additional person ') + (index + 1); input.value = person; input.dataset.personIndex = String(index); input.setAttribute('aria-label', tr('Name der weiteren Person ', 'Name of additional person ') + (index + 1));
        var remove = document.createElement('button'); remove.className = 'mg-icon-button'; remove.type = 'button'; remove.dataset.removePerson = String(index); remove.setAttribute('aria-label', trf('Person {n} entfernen', 'Remove person {n}', { n: index + 1 })); remove.textContent = '×';
        row.appendChild(input); row.appendChild(remove); list.appendChild(row);
      });
      if (add) add.hidden = state.additionalPeople.length >= 4;
    }

    function syncConditionals() {
      root.querySelectorAll('[data-show-when]').forEach(function (node) {
        var pieces = node.dataset.showWhen.split(':');
        node.hidden = state[pieces[0]] !== pieces.slice(1).join(':') || Boolean(activePreset(pieces[0]));
      });
      root.querySelectorAll('[data-show-array]').forEach(function (node) {
        var pieces = node.dataset.showArray.split(':');
        node.hidden = !Array.isArray(state[pieces[0]]) || state[pieces[0]].indexOf(pieces.slice(1).join(':')) === -1;
      });
    }

    function syncChoices() {
      var presets = { genre: activePreset('genre'), language: activePreset('language') };
      root.querySelectorAll('[data-choice]').forEach(function (button) {
        var selected = choiceSelected(button, presets[button.dataset.choice]);
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      root.querySelectorAll('[data-multi]').forEach(function (button) {
        var values = state[button.dataset.multi] || [];
        var active = values.indexOf(button.dataset.value) !== -1;
        var max = Number(button.dataset.max || 99);
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.disabled = !active && values.length >= max;
      });
      root.querySelectorAll('[data-multi-count]').forEach(function (node) {
        var key = node.dataset.multiCount; var max = key === 'moods' ? 3 : 5;
        node.textContent = trf('{count} von maximal {max} ausgewählt', '{count} of up to {max} selected', { count: (state[key] || []).length, max: max });
      });
    }

    function syncFields() {
      root.querySelectorAll('[data-field]').forEach(function (field) {
        var key = field.dataset.field;
        if (field.type === 'checkbox') field.checked = Boolean(state[key]);
        else if (document.activeElement !== field) field.value = state[key] || '';
      });
      var thousands = mgThousands(MG_LOCALE);
      root.querySelectorAll('[data-char-count]').forEach(function (node) {
        var key = node.dataset.charCount; var max = key === 'finishedLyrics' ? 6000 : (key === 'storyOrigin' || key === 'keyMoments') ? 5000 : 3000;
        node.textContent = String((state[key] || '').length).replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + ' / ' + String(max).replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      });
      var name = state.recipientName || tr('diesen Menschen', 'this person');
      var storyTitle = root.querySelector('[data-story-title]');
      var traitsTitle = root.querySelector('[data-traits-title]');
      var messageTitle = root.querySelector('[data-message-title]');
      if (storyTitle) storyTitle.textContent = tr('Jetzt fehlen die Momente, die nur ihr kennt', 'Now we need the moments only you know') + (state.recipientName && (MG_LOCALE === 'de' || isEnglish) ? ', ' + state.recipientName : '') + '.';
      if (traitsTitle) traitsTitle.textContent = tr('Was ist typisch für ', 'What is typical of ') + name + tr('?', '?');
      if (messageTitle) messageTitle.textContent = tr('Was soll ', 'What should ') + name + tr(' nach dem letzten Ton wissen?', ' know after the final note?');
      var possessive = possessiveName();
      var summaryLine = root.querySelector('[data-mg-summary-line]');
      if (summaryLine) {
        var summaryParts = [];
        if (state.recipientName.trim()) summaryParts.push(tr('Für ', 'For ') + state.recipientName.trim());
        var occasionSummary = occasionFields();
        if (occasionSummary.occasion) summaryParts.push(occasionSummary.other || localizedLabel(occasionSummary.occasion));
        if (state.genre && state.genre !== 'Ihr dürft entscheiden') summaryParts.push(genreLabel());
        summaryLine.textContent = summaryParts.join(' · ');
        summaryLine.hidden = !summaryParts.length || ['prep', 'gate', 'songwait', 'loading', 'offer', 'success'].indexOf(currentId) !== -1;
      }
      var storyMeter = root.querySelector('[data-mg-story-meter]');
      if (storyMeter) {
        var storyLength = state.keyMoments.trim().length;
        var storyLevel = storyLength === 0 ? 0 : storyLength < 60 ? 1 : storyLength < 160 ? 2 : 3;
        storyMeter.dataset.level = String(storyLevel);
        if (detailsNudgeShown && currentId === 'details') nextButton.textContent = storyLength >= 20 ? tr('Weiter →', 'Continue →') : tr('Ohne weitere Details weiter →', 'Continue without more details →');
        var storyMeterText = storyMeter.querySelector('[data-mg-story-meter-text]');
        if (storyMeterText) storyMeterText.textContent = [
          tr('Tipp: Schon 2–3 Stichpunkte machen den Song deutlich persönlicher.', 'Tip: just 2–3 notes make the song much more personal.'),
          tr('Guter Anfang! Ein konkretes Detail – ein Ort, ein Insider, ein Satz – macht den Unterschied.', 'Good start! One concrete detail – a place, an inside joke, a phrase – makes the difference.'),
          tr('Sehr schön – noch eine Erinnerung, und der Song wird unverwechselbar.', 'Lovely – one more memory and the song becomes unmistakably yours.'),
          tr('Perfekt – daraus lässt sich ein sehr persönlicher Song schreiben.', 'Perfect – that is plenty for a truly personal song.')
        ][storyLevel];
      }
      var detailsTitle = root.querySelector('[data-details-title]');
      var nameTitle = root.querySelector('[data-name-title]');
      var prepTitle = root.querySelector('[data-prep-title]');
      var emailTitle = root.querySelector('[data-email-title]');
      var offerEmail = root.querySelector('[data-offer-email]');
      var recipientPick = RECIPIENT_PICKS[state.recipientPick];
      var nameName = state.recipientName.trim();
      if (nameTitle) nameTitle.textContent = recipientPick && state.recipientPick !== 'other'
        ? trf('Wie heißt {who}?', 'What is {who}’s name?', function (lang) { return { who: pickWho(state.recipientPick, recipientPick, lang) }; })
        : tr('Wie heißt dein Herzensmensch?', 'What is their name?');
      if (detailsTitle) detailsTitle.textContent = nameName ? trf('Was soll in {who} Song vorkommen?', 'What should be part of {who} song?', possessiveValues) : tr('Was soll im Song vorkommen?', 'What should be part of the song?');
      if (prepTitle) prepTitle.textContent = nameName ? trf('Wir bereiten {who} Song vor …', 'We are preparing {who} song …', possessiveValues) : tr('Wir bereiten deinen Song vor …', 'We are preparing your song …');
      if (emailTitle) emailTitle.textContent = nameName ? trf('{who} Song kann starten.', '{who} song can begin.', possessiveValues) : tr('Dein Song kann starten.', 'Your song can begin.');
      root.querySelectorAll('[data-offer-recipient]').forEach(function (node) { node.textContent = nameName || tr('deine besondere Person', 'your special person'); });
      root.querySelectorAll('[data-offer-genre]').forEach(function (node) { node.textContent = genreLabel(); });
      var offerOccasion = occasionFields();
      root.querySelectorAll('[data-offer-occasion]').forEach(function (node) { node.textContent = offerOccasion.other || localizedLabel(offerOccasion.occasion || tr('euer Moment', 'your moment')); });
      var offerMeta=root.querySelector('[data-mg-offer-meta]'); if(offerMeta)offerMeta.textContent=[offerOccasion.occasion?(offerOccasion.other||localizedLabel(offerOccasion.occasion)):'',state.genre&&state.genre!=='Ihr dürft entscheiden'?genreLabel():'',state.voice&&state.voice!=='Ihr dürft entscheiden'?voiceLabel():''].filter(Boolean).join(' · ');
      if (currentId === 'offer') renderHoerprobe();
      var contextAudio = root.querySelector('[data-mg-context-audio]');
      if(contextAudio){
        var genreButtons=Array.from(root.querySelectorAll('[data-choice="genre"]'));
        var selectedGenre=selectedChoiceButton('genre');
        var source=selectedGenre && selectedGenre.parentElement.querySelector('audio source');
        var contextLabel=root.querySelector('[data-mg-context-label]');
        if(!source){var defaultGenre=genreButtons.find(function(button){return button.dataset.value==='Pop';});source=defaultGenre&&defaultGenre.parentElement.querySelector('audio source');}
        if(source && contextAudio.querySelector('source').getAttribute('src')!==source.getAttribute('src')){contextAudio.pause();contextAudio.querySelector('source').src=source.getAttribute('src');contextAudio.load();}
        if(contextLabel)contextLabel.textContent=selectedGenre&&selectedGenre.parentElement.querySelector('audio')?tr('Stilbeispiel (nicht dein Song): ','Style example (not your song): ')+genreLabel():tr('Ein Beispiel aus unserem Angebot (nicht dein Song)','An example from our collection (not your song)');
      }
      if (offerEmail) {
        offerEmail.textContent = state.email || tr('E-Mail aus deinem gespeicherten Songprofil','Email from your saved song profile');
        if (offerEmail.parentElement) offerEmail.parentElement.hidden = false;
      }
      root.querySelectorAll('[data-mg-lyric-name]').forEach(function (node) { node.textContent = state.recipientName || tr('du', 'you'); });
    }

    function christmasSeasonActive() {
      // One-off 2026 season, boundaries in Europe/Berlin (including DST).
      var now = Date.now();
      return now >= Date.parse('2026-09-14T00:00:00+02:00') && now < Date.parse('2026-12-28T00:00:00+01:00');
    }

    function syncChristmasOccasion() {
      var choice = root.querySelector('[data-mg-christmas]');
      // Keep an existing customer's choice visible when resuming after the season.
      if (choice) choice.hidden = !christmasSeasonActive() && state.occasionPick !== 'weihnachten';
      var guide = root.querySelector('.mg-story-guide');
      if (guide) guide.textContent = state.occasionPick === 'weihnachten'
        ? tr('Was macht diesen Menschen besonders – und was möchtest du zu Weihnachten sagen? Stichpunkte reichen.', 'What makes this person special – and what would you like to say at Christmas? Short notes are enough.')
        : tr('Eine gemeinsame Erinnerung, ein typischer Satz, das, was du sagen möchtest. Stichpunkte reichen.', 'A shared memory, a typical phrase, what you want to say. Short notes are enough.');
    }

    // "Weitere Personen …" / "Weitere Anlässe …" stay open once used or when a hidden tile is selected.
    function syncMorePanels() {
      root.querySelectorAll('[data-mg-more-panel]').forEach(function (panel) {
        var toggle = root.querySelector('[data-mg-more="' + panel.dataset.mgMorePanel + '"]');
        var open = panel.dataset.open === 'true' || Boolean(panel.querySelector('.is-selected'));
        panel.hidden = !open;
        if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      var pronunciation = root.querySelector('[data-mg-pron-panel]');
      var pronunciationToggle = root.querySelector('[data-mg-pron-toggle]');
      if (pronunciation) {
        var showPronunciation = pronunciation.dataset.open === 'true' || Boolean(state.pronunciation.trim());
        pronunciation.hidden = !showPronunciation;
        if (pronunciationToggle) { pronunciationToggle.hidden = showPronunciation; pronunciationToggle.setAttribute('aria-expanded', showPronunciation ? 'true' : 'false'); }
      }
    }

    function syncAllFields() {
      syncChristmasOccasion();
      renderPeople(); syncChoices(); syncFields(); syncConditionals(); syncMorePanels();
    }

    function prepareTurnstile() {
      if (root.dataset.turnstileEnabled !== 'true' || window.turnstile) return;
      if (document.querySelector('script[src*="challenges.cloudflare.com/turnstile/v0/api.js"]')) return;
      var script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.addEventListener('error', function () { script.remove(); root.dataset.turnstileFailed = 'true'; });
      document.head.appendChild(script);
    }
    window.mgTurnstileError = function () {
      document.querySelectorAll('[data-mg-configurator]').forEach(function (node) { node.dataset.turnstileFailed = 'true'; });
      return true;
    };
    window.mgTurnstileSuccess = function () {
      document.querySelectorAll('[data-mg-configurator]').forEach(function (node) { delete node.dataset.turnstileFailed; });
    };
    async function waitForTurnstileToken(maxMs, aborted, exclude) {
      var until = Date.now() + maxMs;
      while (Date.now() < until && root.dataset.turnstileFailed !== 'true' && !(aborted && aborted())) {
        var field = root.querySelector('[name="cf-turnstile-response"]');
        var token = field ? String(field.value || '').trim() : '';
        if (token && token !== exclude) return token;
        await new Promise(function (resolve) { window.setTimeout(resolve, 200); });
      }
      return '';
    }

    function showStep(id) {
      window.clearTimeout(autoAdvanceTimer);
      window.clearTimeout(prepTimer);
      var outgoingPanel = root.querySelector('[data-step="' + currentId + '"]');
      if (outgoingPanel && currentId !== id) outgoingPanel.querySelectorAll('audio').forEach(function (audio) { audio.pause(); });
      var groupedSteps = { names: 'name', connection: 'occasion', moods: 'voice', senderIdentity: 'details', pronunciation: 'name', favoriteArtist: 'details' };
      id = groupedSteps[id] || id;
      var seq = sequence();
      if (briefingLocked && ['songwait', 'offer', 'success', 'loading'].indexOf(id) === -1) id = 'offer';
      if (['prep', 'gate', 'songwait', 'loading', 'offer', 'success'].indexOf(id) === -1 && seq.indexOf(id) === -1) id = 'recipient';
      if (['genre', 'voice', 'language', 'details', 'prep', 'gate'].indexOf(id) !== -1 && !savedConfigurationId) prepareTurnstile();
      currentId = id;
      if (id === 'offer') applyAbArm();
      document.body.classList.toggle('mg-offer-open', id === 'offer');
      root.querySelectorAll('[data-step]').forEach(function (panel) { panel.hidden = panel.dataset.step !== id; });
      var panel = root.querySelector('[data-step="' + id + '"]');
      var questions = questionIds();
      var totalSteps = questions.length;
      var questionIndex = questions.indexOf(id);
      var completeScreen = questionIndex === -1;
      var progressOuter = root.querySelector('.mg-progress-wrap');
      if (progressOuter) progressOuter.hidden = completeScreen;
      var percent = completeScreen ? 100 : Math.max(4, ((questionIndex + 1) / totalSteps) * 100);
      phaseLabel.textContent = panel ? panel.dataset.phase : tr('Person', 'Person');
      counterLabel.textContent = completeScreen ? '' : trf('Schritt {n} von {total}', 'Step {n} of {total}', { n: questionIndex + 1, total: totalSteps });
      progressBar.style.width = percent + '%'; progressWrap.setAttribute('aria-valuenow', String(Math.round(percent)));
      var key = AUTO_STEP_KEYS[id];
      enteredWithAnswer = Boolean(key && state[key]);
      var dock = root.querySelector('[data-mg-turnstile-dock]');
      if (dock) dock.hidden = ['songwait', 'offer', 'success', 'loading'].indexOf(id) !== -1;
      var toast = root.querySelector('[data-mg-hp-toast]');
      if (toast && id !== 'offer') toast.hidden = true;
      if (id !== 'offer') stopHoerprobePolling();
      if (id !== 'songwait') stopSongwait();
      if (id === 'offer') { updateOfferTotal(); renderHoerprobe(); pollHoerprobe(); }
      syncAllFields(); syncNavigation(); syncBriefingLock(); setError(''); saveDraft();
      if (id === 'prep') { runPreparation(); startHoerprobe(); }
      if (id === 'gate') { startHoerprobe(); syncGateBadge(); }
      if (id === 'songwait') startSongwait();
      var heading = panel && panel.querySelector('h2[tabindex="-1"]'); if (heading) heading.focus({ preventScroll: true });
      // Jump (not glide) to the top of the new step, like a page change.
      scrollToElement(root, 'start', true);
      if (id === 'name' && !state.recipientName.trim() && window.matchMedia('(hover: hover)').matches) {
        var nameField = root.querySelector('[data-field="recipientName"]');
        if (nameField) try { nameField.focus({ preventScroll: true }); } catch (ignore) {}
      }
      emit(root, 'mg_step_view', { section_id: root.dataset.sectionId || '', step_id: id, total_steps: totalSteps, path: pathName() });
    }

    function validationMessage(id) {
      if (id === 'recipient' && !state.recipientPick && !state.recipientRole) return tr('Bitte wähle aus, für wen der Song ist.', 'Please choose who the song is for.');
      if (id === 'recipientOther' && state.recipientPick === 'other' && state.recipientRoleOther.trim().length < 2) return tr('Für wen ist der Song genau? Ein Wort reicht, z. B. Schwiegermutter.', 'Who exactly is the song for? One word is enough, e.g. mother-in-law.');
      if (id === 'occasion' && !state.occasionPick && !state.occasion) return tr('Bitte wähle einen Anlass.', 'Please choose an occasion.');
      if (id === 'occasionOther' && state.occasionPick === 'other' && state.occasionOther.trim().length < 2) return tr('Welcher Anlass ist es? Ein Stichwort reicht.', 'Which occasion is it? One word is enough.');
      if (id === 'name' && !state.recipientName.trim()) return tr('Bitte gib einen Namen ein – so, wie er im Song vorkommen soll.', 'Please enter a name – just as it should appear in the song.');
      if (id === 'genreOther' && state.genre === 'Andere Musikrichtung' && state.genreOther.trim().length < 2) return tr('Welcher Stil soll es sein? Ein Stichwort reicht, z. B. Bossa Nova.', 'Which style should it be? One word is enough, e.g. bossa nova.');
      if (id === 'language' && !state.language) return tr('Bitte wähle die Sprache des Songs.', 'Please choose the song language.');
      if (id === 'languageOther' && state.language === 'Andere Sprache' && state.languageOther.trim().length < 2) return tr('Welche Sprache soll es sein?', 'Which language should it be?');
      if (id === 'details' && state.lyricsMode === 'finishedLyrics' && !state.finishedLyrics.trim()) return tr('Bitte füge deinen Songtext ein – oder schreib doch lieber Stichpunkte.', 'Please paste your lyrics – or share notes instead.');
      return '';
    }

    function next() {
      var panel = root.querySelector('[data-step="' + currentId + '"]');
      if (!panel) return;
      if (currentId === 'genre' && !state.genre) state.genre = 'Ihr dürft entscheiden';
      if (currentId === 'voice' && !state.voice) state.voice = 'Ihr dürft entscheiden';
      if (panel.dataset.kind === 'question') {
        var groupChecks = { recipient: ['recipient', 'recipientOther'], occasion: ['occasion', 'occasionOther'], name: ['name'], genre: ['genreOther'], voice: [], language: ['language', 'languageOther'], details: ['details'] };
        var failedKey = (groupChecks[currentId] || [currentId]).find(function (key) { return Boolean(validationMessage(key)); });
        if (failedKey) { setError(validationMessage(failedKey), failedKey === 'details' ? 'finishedLyrics' : failedKey); emit(root, 'mg_validation_error', { section_id: root.dataset.sectionId || '', step_id: currentId, total_steps: totalStepCount(), path: pathName() }); return; }
        // One gentle, non-blocking nudge: an empty story is the main cause of generic songs.
        if (currentId === 'details' && state.lyricsMode !== 'finishedLyrics' && state.keyMoments.trim().length < 20 && !detailsNudgeShown) {
          detailsNudgeShown = true;
          setError(tr('Schon ein, zwei Stichpunkte – ein Insider, ein Ort oder ein typischer Satz von euch – machen den Song deutlich persönlicher. Du kannst aber auch direkt weitergehen.', 'Just one or two notes – an inside joke, a place or a phrase you share – make the song much more personal. You can also continue right away.'), 'details', true);
          nextButton.textContent = tr('Ohne weitere Details weiter →', 'Continue without more details →');
          return;
        }
        emit(root, 'mg_step_complete', { section_id: root.dataset.sectionId || '', step_id: currentId, total_steps: totalStepCount(), path: pathName() });
      }
      var seq = sequence(); var index = seq.indexOf(currentId);
      if (index >= seq.length - 1) showStep('prep'); else showStep(seq[index + 1]);
    }

    function back() {
      if (briefingLocked) { setError(tr('Dein Briefing ist bereits gespeichert. Bitte schließe jetzt nur noch das Hinzufügen zum Warenkorb ab.', 'Your brief is already saved. Please complete only the remaining cart step.')); return; }
      var seq = sequence();
      if (['prep', 'gate', 'summary'].indexOf(currentId) !== -1) { showStep(seq[seq.length - 1]); return; }
      var index = seq.indexOf(currentId);
      if (index <= 0) { showStep('recipient'); return; }
      showStep(seq[index - 1]);
    }

    function makeSummaryCard(title, lines) {
      var card = document.createElement('article'); card.className = 'mg-summary-card';
      var heading = document.createElement('h3'); heading.textContent = title; card.appendChild(heading);
      lines.filter(Boolean).forEach(function (line) { var p = document.createElement('p'); p.textContent = line; card.appendChild(p); });
      return card;
    }

    function recipientRoleLabel() {
      var labels = isEnglish || MG_LOCALE !== 'de' ? {
        partner: 'Partner', child: 'Daughter / son', parent: 'Mother / father',
        sibling: 'Sister / brother', friend: 'Friend', grandparents: 'Grandparents', other: 'Another special person'
      } : {
        partner: 'Partnerin / Partner', child: 'Tochter / Sohn', parent: 'Mutter / Vater',
        sibling: 'Schwester / Bruder', friend: 'Freundin / Freund', grandparents: 'Großeltern', other: 'Andere besondere Person'
      };
      // Paket-Sprachen: MG_PACK.roles über die englischen Bezeichnungen legen (fehlende Rolle bleibt Englisch).
      if (MG_LOCALE !== 'de' && !isEnglish) {
        var packRoles = mgPack(MG_LOCALE) && mgPack(MG_LOCALE).roles;
        labels = Object.assign({}, labels, packRoles && typeof packRoles === 'object' ? packRoles : {});
      }
      return state.recipientRole === 'other' && state.recipientRoleOther.trim()
        ? state.recipientRoleOther.trim()
        : labels[state.recipientRole] || '';
    }

    function renderSummary() {
      var summary = root.querySelector('[data-mg-summary]'); if (!summary) return; summary.textContent = '';
      var occasion = state.occasion === 'Ein anderer Anlass' ? state.occasionOther : localizedLabel(state.occasion);
      var connection = state.connection === 'Etwas anderes' ? state.connectionOther : localizedLabel(state.connection);
      var genre = presetLabel('genre') || (state.genre === 'Andere Musikrichtung' && state.genreOther ? state.genreOther : localizedLabel(state.genre));
      var language = presetLabel('language') || (state.language === 'Andere Sprache' ? state.languageOther : localizedLabel(state.language));
      var traits = state.traits.filter(function (trait) { return trait !== 'Etwas Eigenes'; }).map(localizedLabel);
      if (state.traits.indexOf('Etwas Eigenes') !== -1 && state.customTrait.trim()) traits.push(state.customTrait.trim());
      summary.appendChild(makeSummaryCard(tr('Person & Anlass', 'Person & occasion'), [
        tr('Beschenkte Person: ', 'Recipient: ') + (state.recipientName || tr('Noch kein Name', 'No name yet')),
        recipientRoleLabel() ? tr('Beziehung: ', 'Relationship: ') + recipientRoleLabel() : '',
        state.senderNames ? tr('Absender: ', 'From: ') + state.senderNames : '',
        state.pronunciation ? tr('Aussprache: ', 'Pronunciation: ') + state.pronunciation : '',
        occasion ? tr('Anlass: ', 'Occasion: ') + occasion : '',
        connection ? tr('Verbindung: ', 'Connection: ') + connection : '',
        isFamily() && state.additionalPeople.filter(Boolean).length ? tr('Weitere Personen: ', 'Additional people: ') + state.additionalPeople.filter(Boolean).join(', ') : ''
      ]));
      summary.appendChild(makeSummaryCard(tr('Klang & Stimme', 'Sound & voice'), [
        state.genre ? tr('Musikrichtung: ', 'Musical style: ') + genre : '',
        state.moods.length ? tr('Stimmung: ', 'Mood: ') + state.moods.map(localizedLabel).join(', ') : '',
        state.voice ? tr('Stimme: ', 'Voice: ') + localizedLabel(state.voice) : '',
        state.perspective ? tr('Perspektive: ', 'Perspective: ') + localizedLabel(state.perspective) : '',
        language ? tr('Sprache: ', 'Language: ') + language : '',
        state.favoriteArtist ? tr('Musikalische Referenz: ', 'Musical reference: ') + state.favoriteArtist : ''
      ]));
      summary.appendChild(makeSummaryCard(tr('Eure Geschichte', 'Your story'), [
        state.storyOrigin ? tr('Der Anfang: ', 'The beginning: ') + state.storyOrigin : '',
        state.keyMoments ? tr('Wichtige Momente: ', 'Important moments: ') + state.keyMoments : '',
        traits.length ? tr('Eigenschaften: ', 'Traits: ') + traits.join(', ') : ''
      ]));
      summary.appendChild(makeSummaryCard(tr('Botschaft & Hinweise', 'Message & notes'), [
        state.coreMessage ? tr('Kernbotschaft: ', 'Core message: ') + state.coreMessage : '',
        state.mustInclude ? tr('Unbedingt erwähnen: ', 'Must include: ') + state.mustInclude : '',
        state.mustAvoid ? tr('Nicht erwähnen: ', 'Do not mention: ') + state.mustAvoid : '',
        state.additionalNotes ? tr('Weitere Hinweise: ', 'Additional notes: ') + state.additionalNotes : ''
      ]));
      var count = root.querySelector('[data-summary-count]'); if (count) count.textContent = trf('{count} Schritte vorbereitet', '{count} steps prepared', { count: totalStepCount() });
    }

    function webhookPayload(variantId) {
      normalizeDependentState();
      var recipient = recipientFields(), occasion = occasionFields();
      var indie = state.genre === 'Indie / Alternative';
      return {
        schemaVersion: 'melodyglow-songprofile.v1',
        customerLocale: MG_LOCALE,
        request_id: requestId,
        path: pathName(),
        recipientRole: recipient.role,
        recipientRoleOther: recipient.other,
        occasion: occasion.occasion,
        occasionOther: occasion.other,
        recipientName: state.recipientName.trim(),
        senderNames: '',
        pronunciation: state.pronunciation,
        // No longer asked; the core still requires a value.
        connection: tr('Keine Angabe', 'Not specified'),
        connectionOther: '',
        additionalPeople: isFamily() ? state.additionalPeople.filter(Boolean) : [],
        genre: indie ? 'Andere Musikrichtung' : state.genre,
        genreOther: indie ? 'Indie / Alternative' : state.genre === 'Andere Musikrichtung' ? state.genreOther : '',
        moods: [],
        senderIdentity: '',
        voice: state.voice,
        perspective: state.perspective,
        language: state.language,
        languageOther: state.language === 'Andere Sprache' ? state.languageOther : '',
        storyOrigin: state.storyOrigin,
        keyMoments: state.keyMoments,
        traits: state.traits,
        customTrait: state.traits.indexOf('Etwas Eigenes') !== -1 ? state.customTrait : '',
        coreMessage: state.coreMessage,
        mustInclude: state.mustInclude,
        mustAvoid: state.mustAvoid,
        additionalNotes: state.additionalNotes,
        favoriteArtist: state.favoriteArtist,
        lyricsMode: state.lyricsMode,
        finishedLyrics: state.lyricsMode === 'finishedLyrics' ? state.finishedLyrics : '',
        email: state.email,
        privacyNoticeShown: true,
        recoveryAccepted: state.recoveryAccepted === true,
        emailConsentVersion: state.recoveryAccepted === true ? 'email-personal-v1-2026-09-22' : null,
        shopifyOrderSyncRequested: true,
        shopifyOrderSyncTarget: 'admin_order_metafield',
        product_variant_id: String(variantId)
      };
    }

    function selectedVariantId() {
      if (savedConfigurationId && /^\d{6,20}$/.test(pendingVariantId)) return pendingVariantId;
      var configured = String(root.dataset.variantId || '').trim();
      if (root.dataset.allowQueryVariant === 'true') {
        var queryVariant = new URLSearchParams(window.location.search).get('variant');
        if (queryVariant && /^\d{6,20}$/.test(queryVariant)) configured = queryVariant;
      }
      return /^\d{6,20}$/.test(configured) ? configured : '';
    }

    async function loadCart(shopRoot) {
      var response = await fetchWithTimeout(shopRoot + 'cart.js', {
        method: 'GET', credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' }
      }, 15000);
      if (!response.ok) throw new Error('cart_check_failed');
      var cart = await response.json();
      if (!cart || !Array.isArray(cart.items)) throw new Error('cart_check_failed');
      return cart;
    }

    function configurationProperty(item) {
      var properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
      return String(properties._configuration_id || '');
    }

    async function normalizeConfigurationInCart(shopRoot, configurationId, variantId) {
      var cart = await loadCart(shopRoot);
      var allMatches = cart.items.filter(function (item) { return configurationProperty(item) === configurationId; });
      if (!allMatches.length) return false;
      var exactMatches = allMatches.filter(function (item) { return String(item.variant_id || item.id || '') === String(variantId); });
      if (exactMatches.length !== allMatches.length || !exactMatches.length) throw new Error('cart_variant_conflict');
      for (var index = 0; index < exactMatches.length; index += 1) {
        var item = exactMatches[index];
        var desiredQuantity = index === 0 ? 1 : 0;
        if (Number(item.quantity) === desiredQuantity) continue;
        var change = await fetchWithTimeout(shopRoot + 'cart/change.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: desiredQuantity })
        }, 20000);
        if (!change.ok) throw new Error('cart_normalize_failed');
      }
      return true;
    }

    async function ensureConfigurationInCart(shopRoot, variantId, configurationId) {
      await flushWish();
      if (await normalizeConfigurationInCart(shopRoot, configurationId, variantId)) return true;
      if (cartAttemptedAt && Date.now() - cartAttemptedAt < 60000) throw new Error('cart_state_pending');
      cartAttemptedAt = Date.now();
      savePendingCart();
      var cartResponse;
      try {
        cartResponse = await fetchWithTimeout(shopRoot + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { '_configuration_id': configurationId } }] })
        }, 20000);
      } catch (error) {
        try {
          if (await normalizeConfigurationInCart(shopRoot, configurationId, variantId)) return true;
        } catch (recoveryError) {
          if (recoveryError && recoveryError.message === 'cart_variant_conflict') throw recoveryError;
        }
        throw new Error('cart_add_uncertain');
      }
      if (!cartResponse.ok) {
        var status = Number(cartResponse.status || 0);
        var definitiveClientFailure = status >= 400 && status < 500 && [408, 425, 429].indexOf(status) === -1;
        if (definitiveClientFailure) {
          cartAttemptedAt = 0;
          savePendingCart();
          throw new Error('cart_add_failed');
        }
        try {
          if (await normalizeConfigurationInCart(shopRoot, configurationId, variantId)) return true;
        } catch (recoveryError) {
          if (recoveryError && recoveryError.message === 'cart_variant_conflict') throw recoveryError;
        }
        throw new Error('cart_add_uncertain');
      }
      return true;
    }

    function selectedOfferAddons() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-mg-addon]:checked')).map(function (input) {
        return { id: String(input.value || ''), cents: Number(input.dataset.priceCents || 0) };
      }).filter(function (addon) { return /^\d{6,20}$/.test(addon.id); });
    }

    function updateOfferDelivery() {
      var expressSelected = Boolean(root.querySelector('[data-mg-express-addon]:checked'));
      var hours = expressSelected
        ? Math.max(1, Number(root.dataset.expressDeliveryHours || 2))
        : Math.max(1, Number(root.dataset.standardDeliveryHours || 24));
      var label = expressSelected ? tr('Mit Express voraussichtlich per E-Mail bis', 'With express, expected by email by') : tr('Voraussichtlich per E-Mail bis', 'Expected by email by');
      root.querySelectorAll('[data-mg-offer-delivery-label]').forEach(function (node) { node.textContent = label; });
      root.querySelectorAll('[data-mg-offer-delivery-time]').forEach(function (node) { node.textContent = formatReadyAt(node, hours); });
    }

    function updateOfferTotal() {
  updateOfferDelivery();
  var addons=selectedOfferAddons(),total=Number(root.dataset.basePriceCents||0);
  addons.forEach(function(addon){total+=addon.cents;});
  var kinds=checkedKinds();total-=offerAdjustCents(kinds,giftOffer);syncOfferMarkers(kinds);
  var valid=validOfferPrice();
  total-=activeCreditCents();renderOfferSavings();
  var formatted=valid?money(total):'—';
  root.querySelectorAll('[data-mg-offer-total]').forEach(function(n){n.textContent=formatted;});
  var count=root.querySelector('[data-mg-extras-count]');if(count)count.textContent=addons.length?trf('({count} gewählt)','({count} selected)',{count:addons.length}):'';
  var shipping=root.querySelector('[data-mg-physical-delivery]');if(shipping)shipping.hidden=!root.querySelector('[data-mg-addon-kind="acrylic"]:checked');
  checkoutButtons.forEach(function(button){button.disabled=submitInFlight||!savedConfigurationId||!valid;});
  savePendingCart();syncOfferSticky();
}


    function addonConfigurationProperty(item) {
      var properties = item && item.properties && typeof item.properties === 'object' ? item.properties : {};
      return String(properties._melodyglow_addon_for || '');
    }

    async function retainCurrentConfigurationInCart(shopRoot, configurationId, variantId) {
      var selectedIds = selectedOfferAddons().map(function (addon) { return addon.id; });
      function verifyCurrent(cart) {
        var songs = cart.items.filter(function (item) { return configurationProperty(item) === configurationId; });
        var extras = cart.items.filter(function (item) { return addonConfigurationProperty(item) === configurationId; });
        if (songs.length !== 1 || String(songs[0].variant_id || songs[0].id) !== String(variantId) || Number(songs[0].quantity) !== 1 ||
            extras.length !== selectedIds.length || selectedIds.some(function (id) {
              var matches = extras.filter(function (item) { return String(item.variant_id || item.id) === id; });
              return matches.length !== 1 || Number(matches[0].quantity) !== 1;
            })) throw new Error('cart_replace_failed');
      }
      function isPrevious(item) {
        var owner = configurationProperty(item) || addonConfigurationProperty(item);
        return /^mg_[0-9a-f]{32}$/.test(owner) && owner !== configurationId;
      }
      var cart = await loadCart(shopRoot);
      // Never remove a previous song before its replacement and all extras exist.
      verifyCurrent(cart);
      var previous = cart.items.filter(isPrevious);
      if (previous.length) {
        var updates = {};
        previous.forEach(function (item) {
          if (!item.key) throw new Error('cart_replace_failed');
          updates[item.key] = 0;
        });
        var response = await fetchWithTimeout(shopRoot + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }, 20000);
        if (!response.ok) throw new Error('cart_replace_failed');
      }
      var verified = await loadCart(shopRoot);
      verifyCurrent(verified);
      if (verified.items.some(isPrevious)) throw new Error('cart_replace_failed');
    }

    async function syncOfferExtrasInCart(shopRoot, configurationId) {
      var selected = selectedOfferAddons();
      var selectedIds = selected.map(function (addon) { return addon.id; });
      var cart = await loadCart(shopRoot);
      var associated = cart.items.filter(function (item) { return addonConfigurationProperty(item) === configurationId; });
      var seen = {};
      for (var index = 0; index < associated.length; index += 1) {
        var item = associated[index];
        var itemId = String(item.variant_id || item.id || '');
        var keep = selectedIds.indexOf(itemId) !== -1 && !seen[itemId];
        seen[itemId] = keep || seen[itemId];
        if (keep && Number(item.quantity) === 1) continue;
        var change = await fetchWithTimeout(shopRoot + 'cart/change.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: keep ? 1 : 0 })
        }, 20000);
        if (!change.ok) throw new Error('addon_sync_failed');
      }
      var missing = selected.filter(function (addon) { return !seen[addon.id]; });
      if (missing.length) {
        var response = await fetchWithTimeout(shopRoot + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: missing.map(function (addon) { return { id: addon.id, quantity: 1, properties: { '_melodyglow_addon_for': configurationId } }; }) })
        }, 20000);
        if (!response.ok) throw new Error('addon_sync_failed');
      }
    }

    async function removeConfigurationFromCart(shopRoot, configurationId) {
      var cart = await loadCart(shopRoot);
       var matches = cart.items.filter(function (item) { return configurationProperty(item) === configurationId || addonConfigurationProperty(item) === configurationId; });
      for (var index = 0; index < matches.length; index += 1) {
        var change = await fetchWithTimeout(shopRoot + 'cart/change.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: matches[index].key, quantity: 0 })
        }, 20000);
        if (!change.ok) throw new Error('cart_discard_failed');
      }
      var verified = await loadCart(shopRoot);
       if (verified.items.some(function (item) { return configurationProperty(item) === configurationId || addonConfigurationProperty(item) === configurationId; })) throw new Error('cart_discard_failed');
    }

    // Paketwahl Variante B (24.10.2026): Arm je Konfiguration (letzte Hex-Stelle), kein eigenes Cookie.
    function applyAbArm() {
      var mode = root.dataset.mgAbMode || 'off', forced = '';
      try {
        var q = new URLSearchParams(window.location.search).get('mg_ab');
        if (q && /^[ab]$/i.test(q)) window.sessionStorage.setItem('mg_ab_force', q.toUpperCase());
        forced = window.sessionStorage.getItem('mg_ab_force') || '';
      } catch (ignore) {}
      var arm = forced || (mode === 'b' ? 'B' : mode === 'test' && /^mg_[0-9a-f]{32}$/.test(savedConfigurationId) ? (parseInt(savedConfigurationId.slice(-1), 16) % 2 ? 'B' : 'A') : '');
      if (arm) root.dataset.mgAbArm = arm; else delete root.dataset.mgAbArm;
      if (forced) root.dataset.mgAbForced = 'true'; else delete root.dataset.mgAbForced;
      root.dispatchEvent(new CustomEvent('mg:ab-arm'));
    }
    async function syncAbAttribute(shopRoot) {
      var arm = root.dataset.mgAbArm;
      if (!arm || (root.dataset.mgAbMode !== 'test' && !root.dataset.mgAbForced)) return;
      try {
        await fetchWithTimeout(shopRoot + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { '_mg_ab_paket': arm + (root.dataset.mgAbForced ? '-qa' : '') } })
        }, 5000);
      } catch (ignore) {}
    }

    // Rabatte vor der Kasse (29.10.2026). Sicherheitsnetz: Gibt Shopify den versprochenen Rabatt nachweislich nicht
    // (Express im Komplett nicht rabattiert bzw. Set-Code „nicht anwendbar“), geht es NICHT zur Kasse: Auswahl/Preis
    // werden auf den echten Stand gebracht und erklärt. Ohne eindeutige Antwort (Netzfehler, Feld fehlt) geht es weiter.
    function checkoutDiscountQuery(extraCode) {
      var codes = [];
      if (activeCreditCents()) codes.push(verifiedRecoveryCredit.code);
      if (extraCode && codes.indexOf(extraCode) === -1) codes.push(extraCode);
      return codes.length ? '&discount=' + codes.map(encodeURIComponent).join(',') : '';
    }
    async function postCartDiscounts(shopRoot, codes) {
      var response = await fetchWithTimeout(shopRoot + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      }, 15000);
      return response.ok ? response.json() : null;
    }
    async function syncOfferDiscounts(shopRoot) {
      var kinds = checkedKinds(), cart = null;
      if (bundleExpressCents(kinds) || giftSetSavingCents(kinds, giftOffer) || giftCodeInCart) {
        try { cart = await loadCart(shopRoot); } catch (ignore) {}
      }
      if (bundleExpressCents(kinds) && cart) {
        var express = addonInput('express');
        var line = cart.items.filter(function (item) { return addonConfigurationProperty(item) === savedConfigurationId && String(item.variant_id || item.id) === String(express.value); })[0];
        var original = line ? Number(line.original_line_price) : NaN, final = line ? Number(line.final_line_price) : NaN;
        if (original > 0 && final >= original) {
          root.dataset.mgBundleBroken = 'true';
          express.checked = false; express.dispatchEvent(new Event('change', { bubbles: true }));
          emit(root, 'mg_bundle_unavailable', { section_id: root.dataset.sectionId || '', step_id: 'offer' });
          throw new Error('offer_bundle_unavailable');
        }
      }
      var wanted = giftSetSavingCents(kinds, giftOffer) > 0;
      if (!wanted && !giftCodeInCart) return '';
      var others = cart && Array.isArray(cart.discount_codes) ? cart.discount_codes.map(function (d) { return String(d && d.code || ''); }).filter(function (c) { return c && c.toUpperCase() !== GIFT_SET_CODE; }) : [];
      var data = null;
      try { data = await postCartDiscounts(shopRoot, wanted ? others.concat(GIFT_SET_CODE) : others); } catch (ignore) {}
      giftCodeInCart = wanted; savePendingCart();
      if (!wanted) return '';
      var entry = data && Array.isArray(data.discount_codes) ? data.discount_codes.filter(function (d) { return d && String(d.code || '').toUpperCase() === GIFT_SET_CODE; })[0] : null;
      if (entry && entry.applicable === false) {
        try { await postCartDiscounts(shopRoot, others); } catch (ignore) {}
        giftCodeInCart = false; giftOffer = ''; root.dataset.mgGiftOfferBroken = 'true'; updateOfferTotal();
        emit(root, 'mg_gift_code_unavailable', { section_id: root.dataset.sectionId || '', step_id: 'offer' });
        throw new Error('offer_gift_unavailable');
      }
      return GIFT_SET_CODE;
    }

    async function submit() {
      if (submitInFlight || anonymousSubmitWaiting) return;
      if(savedConfigurationId && !validOfferPrice()){setError(tr('Der Preis konnte nicht geladen werden. Bitte lade die Seite erneut.','The price could not be loaded. Please reload this page.'));return;}
      var hoerprobeReceipt = null;
      if (!savedConfigurationId && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email)) {
        anonymousSubmitWaiting = true; submitButton.disabled = true;
        try { await settleHoerprobeStart(); hoerprobeReceipt = usableHoerprobeReceipt(); }
        finally { anonymousSubmitWaiting = false; submitButton.disabled = false; }
      }
      var activeSubmitButton = savedConfigurationId && checkoutButton ? checkoutButton : submitButton;
      if (!savedConfigurationId) prepareTurnstile();
      var turnstileRequired = root.dataset.turnstileEnabled === 'true';
      var turnstileField = root.querySelector('[name="cf-turnstile-response"]');
      var turnstileToken = turnstileField ? String(turnstileField.value || '').trim() : '';
      if (!savedConfigurationId) {
        var emailOkay = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email);
        if (!emailOkay) { setError(tr('Bitte prüfe deine E-Mail-Adresse.', 'Please check your email address.')); var emailField = root.querySelector('[data-field="email"]'); if (emailField) { emailField.setAttribute('aria-invalid', 'true'); emailField.focus(); } return; }
        // The invisible check usually finishes within a few seconds; wait briefly instead of failing right away.
        if (turnstileRequired && !turnstileToken && !hoerprobeReceipt) {
          // A failed check gets a fresh attempt on the next click (only if the Turnstile script is there at all).
          if (root.dataset.turnstileFailed === 'true' && window.turnstile) { delete root.dataset.turnstileFailed; resetTurnstile(); }
          anonymousSubmitWaiting = true; submitButton.disabled = true; submitButton.textContent = tr('Kurze Sicherheitsprüfung …', 'Quick security check …');
          try { turnstileToken = await waitForTurnstileToken(6000); }
          finally { anonymousSubmitWaiting = false; submitButton.disabled = false; submitButton.innerHTML = submitButtonMarkup; }
        }
        if (turnstileRequired && !turnstileToken && !hoerprobeReceipt) {
          setError(root.dataset.turnstileFailed === 'true'
            ? tr('Die Sicherheitsprüfung hat gerade nicht geklappt. Tippe bitte noch einmal auf den Button. Klappt es wieder nicht, deaktiviere kurz deinen Werbeblocker oder öffne die Seite in einem anderen Browser – deine Angaben bleiben gespeichert.', 'The security check did not work just now. Please tap the button again. If it still fails, pause your ad blocker briefly or open this page in another browser – your answers stay saved.')
            : tr('Bitte schließe zuerst die Sicherheitsprüfung ab.', 'Please complete the security check first.'));
          return;
        }
      }
      var webhook = String(root.dataset.webhookUrl || '').trim();
      var variantId = selectedVariantId();
      if (!/^https:\/\//i.test(webhook)) { setError(tr('Der Cloudflare Intake-Endpunkt ist im Theme-Editor noch nicht als HTTPS-URL hinterlegt.', 'The Cloudflare intake endpoint has not yet been configured as an HTTPS URL in the theme editor.')); return; }
      if (!variantId) { setError(tr('Bitte verknüpfe im Theme-Editor ein Song-Produkt oder trage eine gültige Variant-ID ein.', 'Please connect a song product in the theme editor or enter a valid variant ID.')); return; }
      submitInFlight = true; checkoutButtons.forEach(function (button) { button.disabled = true; }); activeSubmitButton.disabled = true; activeSubmitButton.textContent = savedConfigurationId ? tr('Warenkorb wird vorbereitet …', 'Preparing your cart …') : tr('Deine Hörprobe wird geöffnet …', 'Opening your sample …'); syncBriefingLock(); setError('');
      emit(root, 'mg_submit_attempt', { section_id: root.dataset.sectionId || '', step_id: 'gate', total_steps: totalStepCount(), path: pathName() });
      try {
        if (!savedConfigurationId) {
          intakeAttempted = true;
          saveDraft();
          var intakeHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
          if (turnstileToken) intakeHeaders['CF-Turnstile-Response'] = turnstileToken;
          var submittedMetaEmail = state.email;
          var response = await fetchWithTimeout(webhook, { method: 'POST', mode: 'cors', credentials: 'omit', headers: intakeHeaders, body: JSON.stringify(Object.assign(webhookPayload(variantId), hoerprobeReceipt ? { hoerprobe: hoerprobeReceipt } : {})) }, 30000);
          if ((response.status === 403 || response.status === 422) && hoerprobeReceipt) {
            // The Hörprobe receipt was not accepted (403) or the add-on is switched off and the core rejects the field (422): retry once without it.
            // A token sent along is only spent on 403 (the core validates the fields before the bot check).
            var spentToken = response.status === 403 ? turnstileToken : '';
            hp.receipt = null; hoerprobeReceipt = null;
            if (spentToken) resetTurnstile();
            if (!turnstileToken || spentToken) turnstileToken = await waitForTurnstileToken(8000, null, spentToken);
            if (turnstileToken) {
              intakeHeaders['CF-Turnstile-Response'] = turnstileToken;
              response = await fetchWithTimeout(webhook, { method: 'POST', mode: 'cors', credentials: 'omit', headers: intakeHeaders, body: JSON.stringify(webhookPayload(variantId)) }, 30000);
            }
          }
          if (!response.ok) {
            var failure = {};
            try { failure = await response.json(); } catch (ignore) {}
            if (failure && failure.code === 'IDEMPOTENCY_CONFLICT') {
              requestId = makeRequestId(); intakeAttempted = false; saveDraft(); resetTurnstile();
              throw new Error('idempotency_conflict');
            }
            throw new Error(failure && failure.code === 'BOT_CHECK_FAILED' ? 'bot_check_failed' : 'briefing_save_failed');
          }
          var responseData = await response.json();
          var result = responseData.result || responseData.data || responseData;
          if (result.persisted !== true || result.ready_for_cart !== true) throw new Error('briefing_not_ready_for_cart');
          if (result.request_id !== requestId) throw new Error('request_id_mismatch');
          var candidate = result.configuration_id || '';
          if (!/^mg_[0-9a-f]{32}$/.test(String(candidate))) throw new Error('invalid_configuration_id');
          hp.access = result.hoerprobe_access && result.hoerprobe_access.configuration_id === String(candidate) ? result.hoerprobe_access : null;
          if (!hp.startedAt) hp.startedAt = Date.now();
          hp.status = ''; hp.final = false; hp.errors = 0; hp.receipt = null;
          savedConfigurationId = String(candidate);
          pendingVariantId = variantId;
          checkoutStartedAt = 0;
          emit(root, "mg_lead_saved", {email: submittedMetaEmail});
          savePendingCart();
          setBriefingLocked(true);
          showStep(songwaitApplies() ? 'songwait' : 'offer');
          return;
        }
        var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        await ensureConfigurationInCart(shopRoot, variantId, savedConfigurationId);
        await syncOfferExtrasInCart(shopRoot, savedConfigurationId);
        await retainCurrentConfigurationInCart(shopRoot, savedConfigurationId, variantId);
        await syncAbAttribute(shopRoot);
        var offerCode = await syncOfferDiscounts(shopRoot);
        var action = root.dataset.successAction || 'stay';
        // Keep the offer (answers, Hörprobe, wish, extras) for customers who come back from the cart or checkout;
        // verifyCheckoutReturn clears it once the song has left the cart.
        if (action === 'cart' || action === 'checkout') { checkoutStartedAt = Date.now(); savePendingCart(); saveDraft(); }
        else {
          clearPendingCart();
          if (draftEnabled) {
            try { window.localStorage.removeItem(draftKey); } catch (ignore) {}
          }
        }
        emit(root, 'mg_intake_saved', { section_id: root.dataset.sectionId || '', step_id: 'success', total_steps: totalStepCount(), path: pathName() });
        if (action === 'cart') { window.location.assign(root.dataset.cartUrl || '/cart'); return; }
        if (action === 'checkout') { window.location.assign(shopRoot + 'checkout?skip_shop_pay=true' + checkoutDiscountQuery(offerCode)); return; }
        showStep('success');
      } catch (error) {
        if (error && error.message === 'bot_check_failed') hp.receipt = null;
        if (!savedConfigurationId && turnstileRequired && window.turnstile && typeof window.turnstile.reset === 'function') {
          try { window.turnstile.reset(); } catch (ignore) {}
        }
        var message = error && error.message === 'cart_add_failed'
          ? tr('Dein Briefing ist gespeichert, aber die gewählte Produktvariante ist gerade nicht verfügbar. Du kannst den Warenkorb-Schritt erneut versuchen oder diesen Versuch verwerfen und neu beginnen.', 'Your brief is saved, but the selected product variant is currently unavailable. You can retry the cart step or discard this attempt and start again.')
          : error && ['cart_check_failed', 'cart_normalize_failed', 'addon_sync_failed', 'cart_replace_failed'].indexOf(error.message) !== -1
            ? tr('Dein Briefing ist gespeichert, aber der Warenkorb war kurz nicht erreichbar. Deine Angaben sind jetzt gesperrt; bitte klicke erneut, um nur den Warenkorb-Schritt zu wiederholen.', 'Your brief is saved, but the cart was temporarily unavailable. Your details are now locked; click again to repeat only the cart step.')
          : error && ['cart_add_uncertain', 'cart_state_pending'].indexOf(error.message) !== -1
            ? tr('Der Warenkorb wird möglicherweise noch verarbeitet. Bitte warte kurz und klicke erneut; vor einem weiteren Hinzufügen prüfen wir zuerst die vorhandene Konfigurations-ID.', 'The cart may still be processing. Wait a moment and click again; before adding anything else, we first check the existing configuration ID.')
          : error && error.message === 'offer_bundle_unavailable'
            ? tr('Der 2h-Express ist gerade nicht im Paket „Komplett“ enthalten. Wir haben ihn aus deiner Auswahl genommen – bitte prüfe den Gesamtpreis und geh dann erneut zur Kasse.', 'The 2-hour express is not included in “Complete” right now. We have removed it from your selection – please check the total, then continue to checkout again.')
          : error && error.message === 'offer_gift_unavailable'
            ? tr('Der Set-Preis für das Geschenk-Set kann gerade nicht angewendet werden. Aufsteller und Songtext-PDF bleiben zum Einzelpreis in deiner Auswahl, du kannst sie wieder abwählen. Bitte prüfe den Gesamtpreis und geh dann erneut zur Kasse.', 'The gift set price cannot be applied right now. The display and lyrics PDF stay in your selection at their individual prices; you can remove them. Please check the total, then continue to checkout again.')
          : error && error.message === 'cart_variant_conflict'
            ? tr('Diese Konfigurations-ID liegt bereits mit einer anderen Produktvariante im Warenkorb. Bitte entferne diese Position im Warenkorb und versuche es danach erneut.', 'This configuration ID is already in the cart with a different product variant. Remove that item from the cart and then try again.')
          : error && error.message === 'bot_check_failed'
            ? tr('Die Sicherheitsprüfung ist abgelaufen. Bitte bestätige sie erneut und versuche es noch einmal.', 'The security check has expired. Complete it again and retry.')
            : error && error.message === 'idempotency_conflict'
              ? tr('Deine Antworten haben sich nach einem früheren Speicherversuch geändert. Wir haben eine neue technische Anfrage vorbereitet; bitte bestätige die Sicherheitsprüfung erneut und klicke noch einmal.', 'Your answers changed after an earlier save attempt. We prepared a new request; complete the security check again and click once more.')
              : tr('Deine Antworten sind noch da. Die Verbindung hat gerade nicht mitgespielt – bitte versuche es erneut.', 'Your answers are still here. The connection did not work just now – please try again.');
        if (!savedConfigurationId && currentId !== 'gate') showStep('gate');
        setError(message);
      } finally {
        submitInFlight = false;
        if (submitButton) { submitButton.disabled = false; submitButton.innerHTML = submitButtonMarkup; }
      checkoutButtons.forEach(function (button) { button.disabled = false; button.textContent = button.hasAttribute('data-mg-checkout-sticky')?tr('Zur Kasse →','Checkout →'):tr('Weiter zur sicheren Kasse →', 'Continue to secure checkout →'); });
        syncBriefingLock();
      }
    }

    // A gentle "did you mean …?" for common mail domains; never changes the address on its own.
    var EMAIL_DOMAINS = ['gmail.com', 'googlemail.com', 'gmx.de', 'gmx.net', 'gmx.at', 'gmx.ch', 'gmx.com', 'web.de', 't-online.de', 'yahoo.de', 'yahoo.com', 'hotmail.com', 'hotmail.de', 'outlook.com', 'outlook.de', 'live.de', 'icloud.com', 'me.com', 'freenet.de', 'aol.com', 'aol.de', 'posteo.de', 'mail.de', 'online.de', 'arcor.de', 'bluewin.ch'];
    function editDistance(a, b) {
      var row = []; for (var j = 0; j <= b.length; j += 1) row[j] = j;
      for (var i = 1; i <= a.length; i += 1) {
        var previous = row[0]; row[0] = i;
        for (var k = 1; k <= b.length; k += 1) { var kept = row[k]; row[k] = Math.min(row[k] + 1, row[k - 1] + 1, previous + (a[i - 1] === b[k - 1] ? 0 : 1)); previous = kept; }
      }
      return row[b.length];
    }
    // Paket-Sprachen ergänzen ihre üblichen Anbieter (sonst würde z. B. „yahoo.fr“ zu „yahoo.de“ korrigiert).
    function emailDomains() {
      var extra = MG_LOCALE === 'de' || isEnglish ? null : mgPack(MG_LOCALE) && mgPack(MG_LOCALE).emailDomains;
      return Array.isArray(extra) ? extra.filter(function (domain) { return typeof domain === 'string'; }).concat(EMAIL_DOMAINS) : EMAIL_DOMAINS;
    }
    function emailSuggestion(value) {
      var match = String(value || '').trim().toLowerCase().match(/^([^\s@]+)@([^\s@]+\.[a-z]{2,})$/);
      var domains = emailDomains();
      if (!match || domains.indexOf(match[2]) !== -1) return '';
      var best = '', bestScore = 3;
      domains.forEach(function (domain) { var score = editDistance(match[2], domain); if (score < bestScore) { bestScore = score; best = domain; } });
      return best ? match[1] + '@' + best : '';
    }
    function renderEmailSuggestion() {
      var box = root.querySelector('[data-mg-email-suggest]');
      if (!box) return;
      var fix = emailSuggestion(state.email);
      box.textContent = ''; box.hidden = !fix;
      if (!fix) return;
      var button = document.createElement('button'); button.type = 'button'; button.dataset.mgEmailFix = fix; button.textContent = fix;
      box.append(document.createTextNode(tr('Meintest du ', 'Did you mean ')), button, document.createTextNode(tr('?', '?')));
    }

    // After an answer, bring the follow-up field into view (mainly for phones).
    var REVEAL_AFTER = {};
    function revealAfterChoice(key, value) {
      var conditional = root.querySelector('[data-show-when="' + key + ':' + value + '"]');
      var target = conditional && !conditional.hidden ? conditional : (REVEAL_AFTER[key] ? root.querySelector(REVEAL_AFTER[key]) : null);
      if (!target || target.offsetParent === null) return;
      window.setTimeout(function () {
        var viewport = window.innerHeight || document.documentElement.clientHeight;
        var rect = target.getBoundingClientRect();
        if (rect.top > viewport * 0.62) scrollToElement(target, target.matches('[data-mg-nav]') ? 'nearest' : 'center');
      }, 160);
    }

    form.addEventListener('submit', function (event) { event.preventDefault(); });
    root.addEventListener('keydown', function (event) {
      // Enter in a single-line answer moves on, like in any other form. Not on the email step,
      // where the buttons carry different consent choices.
      if (event.key !== 'Enter' || event.isComposing || !event.target.matches || !event.target.matches('input.mg-field')) return;
      if (['prep', 'gate', 'songwait', 'loading', 'offer', 'success'].indexOf(currentId) !== -1) return;
      event.preventDefault();
      if (!nextButton.hidden && !briefingLocked) next();
    });
    root.addEventListener('click', function (event) {
      var storyPrompt = event.target.closest('[data-mg-story-prompt]');
      if (storyPrompt && root.contains(storyPrompt)) {
        if (!markBriefingChanged()) return;
        var storyField = root.querySelector('[data-field="keyMoments"]');
        if (!storyField) return;
        var addition = storyPrompt.dataset.mgStoryPrompt.replace('{name}', state.recipientName.trim() || tr('dir', 'you'));
        var existing = storyField.value.replace(/\s+$/, '');
        storyField.value = ((existing ? existing + '\n' : '') + addition + ' ').slice(0, 5000);
        state.keyMoments = storyField.value;
        syncFields(); saveDraft(); setError('');
        try { storyField.focus(); storyField.setSelectionRange(storyField.value.length, storyField.value.length); } catch (ignore) {}
        return;
      }
      var more = event.target.closest('[data-mg-more]');
      if (more && root.contains(more)) {
        var morePanel = root.querySelector('[data-mg-more-panel="' + more.dataset.mgMore + '"]');
        if (morePanel) {
          morePanel.dataset.open = 'true'; syncMorePanels();
          var firstMore = morePanel.querySelector('button');
          if (firstMore) try { firstMore.focus({ preventScroll: true }); } catch (ignore) {}
        }
        return;
      }
      var pronunciationToggle = event.target.closest('[data-mg-pron-toggle]');
      if (pronunciationToggle && root.contains(pronunciationToggle)) {
        var pronunciationPanel = root.querySelector('[data-mg-pron-panel]');
        if (pronunciationPanel) {
          pronunciationPanel.dataset.open = 'true'; syncMorePanels();
          var pronunciationField = pronunciationPanel.querySelector('[data-field]');
          if (pronunciationField) try { pronunciationField.focus(); } catch (ignore) {}
        }
        return;
      }
      var emailFix = event.target.closest('[data-mg-email-fix]');
      if (emailFix && root.contains(emailFix)) {
        if (!markBriefingChanged()) return;
        state.email = emailFix.dataset.mgEmailFix;
        var emailInput = root.querySelector('[data-field="email"]');
        if (emailInput) emailInput.value = state.email;
        renderEmailSuggestion(); saveDraft(); setError('');
        return;
      }
      var choice = event.target.closest('[data-choice]');
      if (choice && root.contains(choice)) {
        if (choice.hasAttribute('data-mg-christmas') && !christmasSeasonActive() && state.occasionPick !== 'weihnachten') {
          syncChristmasOccasion(); return;
        }
        var choiceStep = currentId;
        if (!markBriefingChanged()) return;
        var presetBefore = activePreset(choice.dataset.choice);
        state[choice.dataset.choice] = choice.dataset.value; setError('');
        if (choice.dataset.choice === 'recipientPick') {
          var pickedRecipient = RECIPIENT_PICKS[state.recipientPick];
          state.recipientRole = pickedRecipient ? pickedRecipient.role : '';
          if (state.recipientPick !== 'other') state.recipientRoleOther = '';
          if (!isFamily()) state.additionalPeople = [];
        }
        if (choice.dataset.choice === 'occasionPick') {
          var pickedOccasion = OCCASION_PICKS[state.occasionPick];
          state.occasion = pickedOccasion ? pickedOccasion.occasion : '';
          if (state.occasionPick !== 'other') state.occasionOther = '';
        }
        if (choice.dataset.choice === 'genre' && state.genre !== 'Andere Musikrichtung') state.genreOther = '';
        if (choice.dataset.choice === 'language' && state.language !== 'Andere Sprache') state.languageOther = '';
        applyOtherPreset(choice, presetBefore);
        syncAllFields(); saveDraft(); emit(root, 'mg_answer_select', { section_id: root.dataset.sectionId || '', step_id: choiceStep, total_steps: totalStepCount(), path: pathName() }); scheduleAutomaticAdvance(choiceStep); revealAfterChoice(choice.dataset.choice, choice.dataset.value);
        if (choiceNeedsDetails(choiceStep)) {
          var followUp = root.querySelector('[data-show-when="' + choice.dataset.choice + ':' + choice.dataset.value + '"] [data-field]');
          if (followUp) try { followUp.focus({ preventScroll: true }); } catch (ignore) {}
        }
        return;
      }
      var multi = event.target.closest('[data-multi]');
      if (multi && root.contains(multi)) {
        if (!markBriefingChanged()) return;
        var key = multi.dataset.multi; var list = state[key] || []; var value = multi.dataset.value; var index = list.indexOf(value); var max = Number(multi.dataset.max || 99);
        if (index >= 0) list = list.filter(function (item) { return item !== value; }); else if (list.length < max) list = list.concat(value);
        if (key === 'traits' && list.indexOf('Etwas Eigenes') === -1) state.customTrait = '';
        state[key] = list; setError(''); syncAllFields(); saveDraft(); emit(root, 'mg_answer_select', { section_id: root.dataset.sectionId || '', step_id: currentId, total_steps: totalStepCount(), path: pathName() }); return;
      }
      var remove = event.target.closest('[data-remove-person]');
      if (remove && root.contains(remove)) { if (!markBriefingChanged()) return; state.additionalPeople.splice(Number(remove.dataset.removePerson), 1); renderPeople(); saveDraft(); return; }
    });
    root.addEventListener('input', function (event) {
      var field = event.target.closest('[data-field]');
      if (field) {
        if (!markBriefingChanged()) return;
        state[field.dataset.field] = field.type === 'checkbox' ? field.checked : field.value;
        if (field.dataset.field === 'email') { var suggestBox = root.querySelector('[data-mg-email-suggest]'); if (suggestBox && !suggestBox.hidden && !emailSuggestion(state.email)) renderEmailSuggestion(); }
        syncFields(); syncConditionals(); saveDraft(); setError(''); return;
      }
      var person = event.target.closest('[data-person-index]');
      if (person) { if (!markBriefingChanged()) return; state.additionalPeople[Number(person.dataset.personIndex)] = person.value; saveDraft(); }
    });
    root.addEventListener('change', function (event) {
      var field = event.target.closest('[data-field]');
      if (field && field.type === 'checkbox') { if (!markBriefingChanged()) return; state[field.dataset.field] = field.checked; saveDraft(); setError(''); }
      if (field && field.dataset.field === 'email') renderEmailSuggestion();
    });
    var addPersonButton = root.querySelector('[data-add-person]');
    if (addPersonButton) addPersonButton.addEventListener('click', function () { if (!markBriefingChanged()) return; if (state.additionalPeople.length < 4) { state.additionalPeople.push(''); renderPeople(); saveDraft(); } });
    startButton.addEventListener('click', function () { started = true; intro.hidden = true; flow.hidden = false; syncAllFields(); showStep(currentId); emit(root, 'mg_configurator_start', { section_id: root.dataset.sectionId || '', step_id: currentId, total_steps: totalStepCount(), path: pathName() }); });
    resetButton.addEventListener('click', function () { resetState(); startButton.textContent = tr('Songreise starten →', 'Start your song journey →'); resetButton.hidden = true; });
    jumpOfferButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var packagesBox = root.querySelector('[data-mg-packages]');
        var buybox = packagesBox && !packagesBox.hidden ? packagesBox : root.querySelector('[data-mg-order-overview]');
        if (!buybox) return;
        emit(root, 'mg_jump_packages', { section_id: root.dataset.sectionId || '', step_id: 'offer' });
        buybox.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        window.setTimeout(function () { try { buybox.focus({ preventScroll: true }); } catch (ignore) {} }, 450);
      });
    });
    editProfileButtons.forEach(function (button) {
      button.addEventListener('click', async function () {
        if (submitInFlight) return;
        if (cartAttemptedAt && Date.now() - cartAttemptedAt < 60000) {
          setError(tr('Der Warenkorb wird möglicherweise noch verarbeitet. Bitte warte kurz und versuche das Ändern danach erneut.', 'The cart may still be processing. Wait briefly, then try editing again.'));
          return;
        }
        submitInFlight = true;
        editProfileButtons.forEach(function (control) { control.disabled = true; });
        if (discardPendingButton) discardPendingButton.disabled = true;
        setError('');
        try {
          if (savedConfigurationId && cartAttemptedAt) {
            var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            await removeConfigurationFromCart(shopRoot, savedConfigurationId);
          }
          resetHoerprobe();
          savedConfigurationId = '';
          pendingVariantId = '';
          requestId = makeRequestId();
          intakeAttempted = false;
          cartAttemptedAt = 0;
          checkoutStartedAt = 0;
          clearPendingCart();
          resetTurnstile();
          setBriefingLocked(false);
          showStep('recipient');
          saveDraft();
        } catch (error) {
          setError(tr('Der Warenkorb konnte nicht sicher geprüft werden. Bitte versuche es später erneut; deine Angaben bleiben erhalten.', 'The cart could not be checked safely. Try again later; your details remain available.'));
        } finally {
          submitInFlight = false;
          editProfileButtons.forEach(function (control) { control.disabled = false; });
          syncBriefingLock();
        }
      });
    });
    if (discardPendingButton) discardPendingButton.addEventListener('click', async function () {
      if (submitInFlight) return;
      if (cartAttemptedAt && Date.now() - cartAttemptedAt < 60000) {
        setError(tr('Der Warenkorb wird möglicherweise noch verarbeitet. Bitte warte insgesamt 60 Sekunden ab; danach prüfen und entfernen wir die Position vor einem Neustart.', 'The cart may still be processing. Please wait a full 60 seconds; then we check and remove the item before restarting.'));
        return;
      }
      var confirmed = window.confirm(tr('Alle Angaben löschen und einen neuen Song beginnen?', 'Delete all details and start a new song?'));
      if (!confirmed) return;
      submitInFlight = true; submitButton.disabled = true; discardPendingButton.disabled = true; setError('');
      try {
        var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        if (savedConfigurationId && cartAttemptedAt) await removeConfigurationFromCart(shopRoot, savedConfigurationId);
        resetState(); resetTurnstile(); started = true; flow.hidden = false; intro.hidden = true; showStep('recipient');
        startButton.textContent = tr('Songreise starten →', 'Start your song journey →'); resetButton.hidden = true;
      } catch (error) {
        setError(tr('Der Warenkorb konnte nicht sicher geprüft und bereinigt werden. Bitte versuche es später erneut; dein gespeichertes Briefing bleibt bis dahin gesperrt.', 'The cart could not be checked and cleared safely. Please try again later; your saved brief remains locked until then.'));
      } finally {
        submitInFlight = false; submitButton.disabled = false; syncBriefingLock();
      }
    });
    nextButton.addEventListener('click', next); backButton.addEventListener('click', back);
    var toGateButton = root.querySelector('[data-mg-to-gate]');
    if (toGateButton) toGateButton.addEventListener('click', function () { showStep('gate'); });
    async function submitFromGate(wantsEmails) {
      if (submitInFlight || anonymousSubmitWaiting) return;
      // A late second tap on the email step must never start the cart/checkout path.
      if (savedConfigurationId) { showStep('offer'); return; }
      if (!savedConfigurationId && state.recoveryAccepted !== wantsEmails) {
        if (!markBriefingChanged()) return;
        state.recoveryAccepted = wantsEmails;
      }
      if (offerOnlyButton) offerOnlyButton.disabled = true;
      try { await submit(); }
      finally { if (offerOnlyButton) offerOnlyButton.disabled = false; }
    }
    submitButton.addEventListener('click', function () { submitFromGate(true); });
    if (offerOnlyButton) offerOnlyButton.addEventListener('click', function () { submitFromGate(false); });
    var giftSheet = root.querySelector('[data-mg-gift-sheet]'), giftSheetDone = false;
    function giftSheetApplies() {
      if (!giftSheet || giftSheetDone || !savedConfigurationId || typeof giftSheet.showModal !== 'function') return false;
      var card = root.querySelector('[data-mg-package="gift"]');
      var acrylic = root.querySelector('[data-mg-addon-kind="acrylic"]'), pdf = root.querySelector('[data-mg-addon-kind="pdf"]');
      return Boolean(card && !card.hidden && acrylic && pdf && !acrylic.checked && validOfferPrice());
    }
    // Geschenk-Sheet „zweite Chance“ (29.10.2026): Set (Aufsteller + PDF) mit 5,00 € Set-Vorteil per Code, sonst voller Preis
    // (Guthaben-Nutzer, Schalter aus, Express inklusive betroffen). Alle Beträge = echte Differenz der Gesamtsumme.
    var giftSheetOffer = 'set_full';
    function giftSheetQuote() {
      var kinds = checkedKinds(), base = Number(root.dataset.basePriceCents || 0) - activeCreditCents();
      function totalFor(list, offer) { return base + addonCentsOf(list) - offerAdjustCents(list, offer); }
      var missing = ['acrylic', 'pdf'].filter(function (k) { var n = addonInput(k); return n && !n.checked; });
      var after = kinds.concat(missing), current = totalFor(kinds, giftOffer);
      var set = giftSetSavingCents(after, 'set') > 0, total = totalFor(after, set ? 'set' : giftOffer);
      var pdf = addonInput('pdf'), pdfAdd = pdf && !pdf.checked ? totalFor(kinds.concat('pdf'), giftOffer) - current : 0;
      return { current: current, add: total - current, total: total, single: addonCentsOf(missing), set: set, pdfAdd: pdf && pdfAdd === Number(pdf.dataset.priceCents || 0) ? pdfAdd : 0 };
    }
    function openGiftSheet() {
      var t = giftSheetQuote();
      giftSheetOffer = t.set ? 'set3490' : 'set_full';
      giftSheet.querySelectorAll('[data-mg-gift-add]').forEach(function (n) { n.textContent = money(t.add); });
      giftSheet.querySelectorAll('[data-mg-gift-total]').forEach(function (n) { n.textContent = money(t.total); });
      giftSheet.querySelectorAll('[data-mg-gift-current]').forEach(function (n) { n.textContent = money(t.current); });
      giftSheet.querySelectorAll('[data-mg-gift-single]').forEach(function (n) { n.hidden = !t.set; n.style.display = t.set ? '' : 'none'; });
      giftSheet.querySelectorAll('[data-mg-gift-single-price]').forEach(function (n) { n.textContent = money(t.single); });
      giftSheet.querySelectorAll('[data-mg-gift-pdf]').forEach(function (n) { n.hidden = !t.pdfAdd; n.style.display = t.pdfAdd ? '' : 'none'; });
      giftSheet.querySelectorAll('[data-mg-gift-pdf-add]').forEach(function (n) { n.textContent = money(t.pdfAdd); });
      var name = String(state.recipientName || '').trim();
      if (name) giftSheet.querySelectorAll('[data-mg-gift-recipient]').forEach(function (n) { n.textContent = name; });
      giftSheet.showModal();
      emit(root, 'mg_gift_sheet_shown', { section_id: root.dataset.sectionId || '', step_id: 'offer', offer: giftSheetOffer });
    }
    function checkoutClick() {
      if (submitInFlight || anonymousSubmitWaiting) return;
      if (giftSheetApplies()) { openGiftSheet(); return; }
      submit();
    }
    if (giftSheet) {
      giftSheet.querySelector('[data-mg-gift-accept]').addEventListener('click', function () {
        giftSheetDone = true;
        var set = giftSheetQuote().set;
        if (set) giftOffer = 'set';
        ['acrylic', 'pdf'].forEach(function (kind) { var n = root.querySelector('[data-mg-addon-kind="' + kind + '"]'); if (n && !n.checked) { n.checked = true; n.dispatchEvent(new Event('change', { bubbles: true })); } });
        updateOfferTotal();
        giftSheet.close();
        emit(root, 'mg_gift_sheet_accept', { section_id: root.dataset.sectionId || '', step_id: 'offer', offer: set ? 'set3490' : 'set_full' });
        submit();
      });
      var giftPdf = giftSheet.querySelector('[data-mg-gift-pdf]');
      if (giftPdf) giftPdf.addEventListener('click', function () {
        giftSheetDone = true;
        var n = addonInput('pdf'); if (n && !n.checked) { n.checked = true; n.dispatchEvent(new Event('change', { bubbles: true })); }
        giftSheet.close();
        emit(root, 'mg_gift_sheet_accept', { section_id: root.dataset.sectionId || '', step_id: 'offer', offer: 'pdf' });
        submit();
      });
      giftSheet.querySelector('[data-mg-gift-decline]').addEventListener('click', function () {
        giftSheetDone = true; giftSheet.close();
        emit(root, 'mg_gift_sheet_decline', { section_id: root.dataset.sectionId || '', step_id: 'offer', offer: giftSheetOffer });
        submit();
      });
      // Escape / Tipp auf den Hintergrund: nur schließen, nicht zur Kasse. Der Schritt kommt nicht noch einmal.
      giftSheet.addEventListener('cancel', function () { giftSheetDone = true; emit(root, 'mg_gift_sheet_close', { section_id: root.dataset.sectionId || '', step_id: 'offer', offer: giftSheetOffer }); });
      giftSheet.addEventListener('click', function (e) { if (e.target === giftSheet) { giftSheetDone = true; giftSheet.close(); emit(root, 'mg_gift_sheet_close', { section_id: root.dataset.sectionId || '', step_id: 'offer', offer: giftSheetOffer }); } });
      giftSheet.addEventListener('close', syncOfferSticky);
    }
    checkoutButtons.forEach(function (button) { button.addEventListener('click', checkoutClick); });
    function validOfferPrice(){
      var base=Number(root.dataset.basePriceCents),addons=selectedOfferAddons();
      return Number.isSafeInteger(base)&&base>0&&addons.every(function(x){return Number.isSafeInteger(x.cents)&&x.cents>=0;});
    }
    var mainCheckoutVisible=false;
    function syncOfferSticky(){
      var bar=root.querySelector('[data-mg-offer-sticky]');if(!bar)return;
      var focused=document.activeElement;
      var typing=focused&&focused.matches('input,textarea,select,[contenteditable="true"]');
      var modal=Array.from(document.querySelectorAll('dialog[open],[role="dialog"],[aria-modal="true"]')).some(function(n){return n.getClientRects().length>0;});
      var keyboard=window.visualViewport&&window.visualViewport.height<window.innerHeight*0.75;
      var pk=root.querySelector('[data-mg-packages]');
      var packagesPassed=!pk||pk.hidden||pk.getBoundingClientRect().top<0;
      var visible=currentId==='offer'&&Boolean(savedConfigurationId)&&validOfferPrice()&&packagesPassed&&!mainCheckoutVisible&&!typing&&!modal&&!keyboard;
      if(bar.hidden===visible)bar.hidden=!visible;
      document.body.classList.toggle('mg-has-buybar',visible);
    }
    ['focusin','focusout','resize'].forEach(function(type){window.addEventListener(type,syncOfferSticky);});
    // Horizon scrollt auf dem Desktop in .page-wrapper, daher scroll im Capture auf document.
    document.addEventListener('scroll',syncOfferSticky,{passive:true,capture:true});
    if(window.visualViewport)window.visualViewport.addEventListener('resize',syncOfferSticky);
    var offerObserver=new MutationObserver(syncOfferSticky);
    offerObserver.observe(root.querySelector('[data-step="offer"]'),{attributes:true,attributeFilter:['hidden']});
    var stickyGuardTimer=window.setInterval(function(){
      if(!root.isConnected){window.clearInterval(stickyGuardTimer);offerObserver.disconnect();return;}
      if(currentId==='offer')syncOfferSticky();
    },750);

    var offerSticky = root.querySelector('[data-mg-offer-sticky]');
    if(offerSticky && checkoutButton && window.IntersectionObserver)new IntersectionObserver(function(entries){mainCheckoutVisible=entries[0].isIntersecting;syncOfferSticky();},{threshold:0.2}).observe(checkoutButton);
    root.querySelectorAll('[data-mg-addon]').forEach(function (input) { input.addEventListener('change', updateOfferTotal); });
    initHoerprobePlayer();
    initSongwait();
    initWish();

    if (!draftEnabled) {
      try { window.localStorage.removeItem(draftKey); } catch (ignore) {}
    }
    var draftFound = restoreDraft();
    var pendingCartFound = restorePendingCart();
    if (pendingCartFound) {
      startButton.textContent = tr('Gespeichertes Briefing zum Warenkorb hinzufügen →', 'Add saved brief to cart →');
      resetButton.hidden = true;
    } else if (draftFound) {
      startButton.textContent = tr('Entwurf fortsetzen →', 'Continue draft →'); resetButton.hidden = false;
    }
    // Links like ?fuer=mama&anlass=geburtstag (homepage cards, ads) pre-select answers that are still empty.
    function applyEntryParams() {
      var params = new URLSearchParams(window.location.search);
      function key(name, alias) { return String(params.get(name) || params.get(alias) || '').toLowerCase().replace(/ß/g, 'ss').replace(/[^a-z]/g, ''); }
      // Ambiguous words (partner, eltern, kind …) are left for the customer to choose.
      var recipients = { mann: 'partner-m', ehemann: 'partner-m', husband: 'partner-m', frau: 'partner-f', ehefrau: 'partner-f', partnerin: 'partner-f', wife: 'partner-f', mama: 'mama', mutter: 'mama', mum: 'mama', mom: 'mama', papa: 'papa', vater: 'papa', dad: 'papa', tochter: 'tochter', daughter: 'tochter', sohn: 'sohn', son: 'sohn', enkel: 'enkel', enkelin: 'enkel', enkelkind: 'enkel', freundin: 'freundin', freund: 'freund', schwester: 'schwester', sister: 'schwester', bruder: 'bruder', brother: 'bruder', oma: 'oma', grandma: 'oma', opa: 'opa', grandpa: 'opa' };
      var occasions = { weihnachten: 'weihnachten', christmas: 'weihnachten', geburtstag: 'geburtstag', birthday: 'geburtstag', jahrestag: 'jahrestag', anniversary: 'jahrestag', hochzeit: 'hochzeit', wedding: 'hochzeit', liebe: 'liebe', love: 'liebe', antrag: 'antrag', heiratsantrag: 'antrag', proposal: 'antrag', geburt: 'geburt', taufe: 'geburt', danke: 'danke', thanks: 'danke', trost: 'trost', mut: 'trost', einfachso: 'einfachso', justbecause: 'einfachso', ruhestand: 'ruhestand', rente: 'ruhestand', retirement: 'ruhestand', erinnerung: 'erinnerung' };
      var recipientPick = recipients[key('fuer', 'for')];
      var occasionPick = occasions[key('anlass', 'occasion')];
      if (occasionPick === 'weihnachten' && !christmasSeasonActive()) occasionPick = '';
      if (recipientPick && !state.recipientPick) { state.recipientPick = recipientPick; state.recipientRole = RECIPIENT_PICKS[recipientPick].role; }
      if (occasionPick && !state.occasionPick) { state.occasionPick = occasionPick; state.occasion = OCCASION_PICKS[occasionPick].occasion; }
    }
    if (!pendingCartFound) applyEntryParams();
    syncAllFields(); syncBriefingLock();
    async function restoreEmailOffer() {
      var fragment = window.location.hash.match(/^#mg-resume=(mg_[0-9a-f]{32})\.(\d{10})\.([A-Za-z0-9_-]{40,100})$/);
      if (!fragment && savedConfigurationId) { try { var previous=JSON.parse(window.sessionStorage.getItem(pendingCartKey+'-resume')||'null'); if(previous && previous[1]===savedConfigurationId && Number(previous[2])>Date.now()/1000) fragment=previous; } catch (_) {} }
      if (!fragment) return;
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
      submitInFlight = true;
      started = true; intro.hidden = true; flow.hidden = false; showStep('loading');
      try {
        var endpoint = new URL(String(root.dataset.webhookUrl || ''));
        endpoint.pathname = '/api/recovery/resume'; endpoint.search = ''; endpoint.hash = '';
        var response = await fetchWithTimeout(endpoint.toString(), { method: 'POST', mode: 'cors', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ configuration_id: fragment[1], expires: Number(fragment[2]), signature: fragment[3] }) }, 30000);
        var result = await response.json();
        if (!response.ok || !result.ok || !result.profile) throw new Error(result.code || 'RECOVERY_UNAVAILABLE');
        verifiedRecoveryCredit=result.recovery_credit||null;
        try { window.sessionStorage.setItem(pendingCartKey+'-resume',JSON.stringify(fragment)); } catch (_) {}
        var profile = result.profile, freshState = initialState();
        Object.keys(freshState).forEach(function (key) { if (Object.prototype.hasOwnProperty.call(profile, key) && typeof freshState[key] === typeof profile[key] && Array.isArray(freshState[key]) === Array.isArray(profile[key])) freshState[key] = profile[key]; });
        resetHoerprobe();
        hp.access = result.hoerprobe_access && result.hoerprobe_access.configuration_id === result.configuration_id ? result.hoerprobe_access : null;
        hp.startedAt = Date.now() - 600000;
        if (result.configuration_id !== savedConfigurationId) checkoutStartedAt = 0;
        state = freshState; otherPresets = {}; requestId = profile.request_id; savedConfigurationId = result.configuration_id; pendingVariantId = String(profile.product_variant_id);
        if(verifiedRecoveryCredit){window.setTimeout(function(){if(currentId==='offer')updateOfferTotal();},Math.min(2147483647,Math.max(0,Date.parse(verifiedRecoveryCredit.expires_at)-Date.now()+100)));}
        intakeAttempted = true; cartAttemptedAt = 0; normalizeDependentState(); syncAllFields(); savePendingCart(); setBriefingLocked(true); showStep('offer');
      } catch (error) {
        showStep('recipient');
        setError(error.message === 'RECOVERY_ALREADY_PURCHASED' ? tr('Dieses Angebot wurde bereits bestellt. Bitte prüfe deine Bestellbestätigung.', 'This offer has already been purchased. Please check your order confirmation.') : tr('Dieser Angebotslink ist abgelaufen oder konnte nicht geladen werden. Du kannst hier einen neuen Song beginnen.', 'This offer link has expired or could not be loaded. You can start a new song here.'));
      } finally { submitInFlight = false; syncBriefingLock(); if (currentId === "offer") updateOfferTotal(); }
    }
    // Back from the checkout: show the saved offer again while this song is still in the cart. An empty cart
    // means the order went through (Shopify empties it) or the song was removed, so the customer starts fresh.
    async function verifyCheckoutReturn() {
      var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var inCart = true;
      try { inCart = (await loadCart(shopRoot)).items.some(function (item) { return configurationProperty(item) === savedConfigurationId; }); } catch (ignore) {}
      if (currentId !== 'loading') return;
      if (inCart) { showStep('offer'); return; }
      resetState(); showStep('recipient');
    }
    startButton.click();
    restoreEmailOffer().then(function () { if (pendingCartFound && currentId === 'loading') verifyCheckoutReturn(); });

  }

  // Mobile: keep a "create your song" button in reach once the hero button has scrolled away.
  function initHome(root) {
    if (root.dataset.mgHomeReady === 'true') return;
    root.dataset.mgHomeReady = 'true';
    var bar = root.querySelector('[data-mg-home-sticky]');
    var heroActions = root.querySelector('.mg-hero .mg-actions');
    if (!bar || !heroActions || !window.IntersectionObserver) return;
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      bar.querySelectorAll('a').forEach(function (link) { link.tabIndex = visible ? 0 : -1; });
    }).observe(heroActions);
  }

  function init(scope) {
    initAudios(scope);
    initDeliveryEstimates(scope);
    scope.querySelectorAll('[data-mg-home]').forEach(initHome);
    scope.querySelectorAll('[data-mg-product]').forEach(initProduct);
    scope.querySelectorAll('[data-mg-configurator]').forEach(initConfigurator);
    scope.querySelectorAll('[data-mg-cart-proof]').forEach(initCartProof);
  }

  window.MelodyGlowThemeRuntime = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var audios = Array.prototype.slice.call(event.target.querySelectorAll('[data-mg-audio]'));
    if (event.target.matches && event.target.matches('[data-mg-audio]')) audios.push(event.target);
    audios.forEach(function (audio) { audio.pause(); audio.removeAttribute('data-mg-ready'); });
    var products = Array.prototype.slice.call(event.target.querySelectorAll('[data-mg-product]'));
    if (event.target.matches && event.target.matches('[data-mg-product]')) products.push(event.target);
    products.forEach(function (productRoot) { productRoot.removeAttribute('data-mg-product-ready'); });
    Array.prototype.slice.call(event.target.querySelectorAll('[data-mg-home]')).forEach(function (homeRoot) { homeRoot.removeAttribute('data-mg-home-ready'); });
    var configurators = Array.prototype.slice.call(event.target.querySelectorAll('[data-mg-configurator]'));
    if (event.target.matches && event.target.matches('[data-mg-configurator]')) configurators.push(event.target);
    configurators.forEach(function (configRoot) { configRoot.removeAttribute('data-mg-configurator-ready'); });
    var cartProofs = Array.prototype.slice.call(event.target.querySelectorAll('[data-mg-cart-proof]'));
    if (event.target.matches && event.target.matches('[data-mg-cart-proof]')) cartProofs.push(event.target);
    cartProofs.forEach(function (cartRoot) { cartRoot.removeAttribute('data-mg-cart-proof-ready'); });
  });
}());

(function () {
  'use strict';
  function initCampaigns() {
    document.querySelectorAll('[data-mg-campaign]').forEach(function (banner) {
      if (banner.dataset.initialized) return;
      banner.dataset.initialized = 'true';
      var start = Date.parse(banner.dataset.start), end = Date.parse(banner.dataset.end);
      // Fixed campaign window; never derive a new deadline from a visit or draft.
      if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start || end - start > 4 * 86400000 || banner.dataset.currency !== 'EUR') return;
      var i18n = window.MelodyGlowLocale, lang = i18n.code(banner.closest('[data-mg-configurator]').dataset.mgLocale);
      var time = banner.querySelector('[data-mg-campaign-end]');
      time.dateTime = new Date(end).toISOString();
      time.textContent = new Intl.DateTimeFormat(i18n.intl(lang), {timeZone:'Europe/Berlin',day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit',timeZoneName:'short'}).format(new Date(end));
      var clock = banner.querySelector('[data-mg-campaign-clock]');
      function tick() {
        var now = Date.now();
        banner.hidden = now < start || now >= end;
        if (!banner.hidden) {
          var seconds = Math.ceil((end - now) / 1000);
          var days = Math.floor(seconds / 86400), hours = Math.floor(seconds % 86400 / 3600), minutes = Math.floor(seconds % 3600 / 60);
          clock.textContent = days + i18n.text(lang, ' Tage ', 'd ') + String(hours).padStart(2,'0') + 'h ' + String(minutes).padStart(2,'0') + 'm ' + String(seconds % 60).padStart(2,'0') + 's';
        }
        if (now >= end || !banner.isConnected) window.clearInterval(interval);
      }
      var interval = window.setInterval(tick, 1000);
      tick();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCampaigns); else initCampaigns();
  document.addEventListener('shopify:section:load', initCampaigns);
}());
